import {
  cancel36mj9lv3a0whl as cancel,
  Key_instancebefxze3q9f64 as Key_instance,
  Job13y4jkazwjho0 as Job,
  cancel2ztysw4v4hav6 as cancel_0,
  GlobalScope_instance3w3xrcgjszz2p as GlobalScope_instance,
  asyncz02dsa2nb2zt as async,
  get_job2zvlvce9o9a29 as get_job,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableJob1w6swnu15iclo as CompletableJob,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  cancel1xim2hrvjmwpn as cancel_1,
  delay3e2ei0hoxjoud as delay,
  CopyableThrowable1mvc99jcyvivf as CopyableThrowable,
  Mutex16li1l0asjv17 as Mutex,
  Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance,
  launch1c91vkjzdi9sd as launch,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  withContextqz5k6d9p9xx5 as withContext,
  await3gx2tubo6ckuc as await_0,
  CancellationExceptionjngvjj221x3v as CancellationException,
  cancel2en0dn4yvpufo as cancel_2,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  cancelConsumed2i0oizqhmljf6 as cancelConsumed,
  Factory_getInstance32nnliw9sj63p as Factory_getInstance,
} from './kotlinx-coroutines-core.mjs';
import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  toString1pkumu07cwy4m as toString,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  constructCallableReference23y65rf941mch as constructCallableReference,
  VOID3gxj6tk5isa35 as VOID,
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  equals2au1ep9vhcato as equals,
  captureStack1fzi4aczwc4hg as captureStack,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  trimIndent1qytc1wvt8suh as trimIndent,
  fromInt1lka3ktyu79a4 as fromInt,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  emptySetcxexqki71qfa as emptySet,
  ArrayList3it5z8td81qkl as ArrayList,
  CancellationException3b36o9qz53rgr as CancellationException_0,
  getKClass3t8tygqu4lcxf as getKClass,
  getStarKTypeProjection316vzroubdy0t as getStarKTypeProjection,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
  setOf1u3mizs95ngxo as setOf,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  joinToString1cxrrlmo0chqs as joinToString,
  setOf45ia9pnfhe90 as setOf_0,
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Unitkvevlwgzwiuc as Unit,
  toLongkk4waq8msp1k as toLong,
  isByteArray4nnzfn1x4o3w as isByteArray,
  Long2qws0ah9gnpki as Long,
  toInt2q8uldh7sc951 as toInt,
  reversed22y3au42jl32b as reversed,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toList2zksu85ukrmi as toList,
  sortedWith2csnbbb21k0lg as sortedWith,
  Collection1k04j3hzsbod0 as Collection,
  StringBuildermazzzhj6kkai as StringBuilder,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  roundToInt1ue8x8yshtznx as roundToInt,
  firstOrNull1982767dljvdy as firstOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  Default_getInstance3u7accvuecmtb as Default_getInstance,
  equalsLong28bsrfhwvd686 as equalsLong,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  multiply18i3gv3wlmcjg as multiply,
  compare2uud5j30pw5xc as compare,
  toNumberlmbpvqo27r53 as toNumber,
  numberToLong345n6tb1n1i71 as numberToLong,
  add85si75olwt6n as add,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea92zjvgyei8ws1 as Result__exceptionOrNull_impl_p6xea9,
  toString30pk9tzaqopn as toString_0,
  trimMarginhyd3fsmh8iev as trimMargin,
  KProperty02ce7r476m8633 as KProperty0,
  createKTypeParameter16gw97ll17xmd as createKTypeParameter,
  removeAll3o43e67jmwdpc as removeAll,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  isBlank1dvkhjjvox3p0 as isBlank,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimStart1mkod6gyztuyy as trimStart,
  endsWith278181ii8uuo as endsWith,
  endsWith3cq61xxngobwh as endsWith_0,
  startsWith26w8qjqapeeq6 as startsWith,
  Default_getInstance2btmaxiazehss as Default_getInstance_0,
  emptyList1g2z5xcrvp2zy as emptyList,
  addAll1k27qatfgp3k5 as addAll,
  KtList3hktaavzmj137 as KtList,
  Key_instance1cfwgdmm6vbbh as Key_instance_0,
  KtMutableList1beimitadwkna as KtMutableList,
  equals2v6cggk171b6e as equals_0,
  flatten2dh4kibw1u0qq as flatten,
  copyToArray2j022khrow2yi as copyToArray,
  intercepted2ogpsikxxj4u0 as intercepted,
  toTypedArray3sl1vhn8ifta0 as toTypedArray,
  SafeContinuation1x0fxyaxo6cwq as SafeContinuation,
  Error3ofk6owajcepa as Error_0,
  decodeToString1dbzcjd620q25 as decodeToString,
  Iterable1y3qizuf89iou as Iterable,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  AttributesJsFn25rjfgcprgprf as AttributesJsFn,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
  PlatformUtils_getInstance3hk77c3xwk5zt as PlatformUtils_getInstance,
  TypeInfo2nbxsuf4v8os2 as TypeInfo,
  instanceOf2cx3k00nj6a0p as instanceOf,
  SilentSupervisorlzoikirj0zeo as SilentSupervisor,
  PipelinePhase2q3d54imxjlma as PipelinePhase,
  KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger,
  Attributes2dg90yv0ot9wx as Attributes,
  get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled,
  getTimeMillis12o7k17x9fmwi as getTimeMillis,
  toLowerCasePreservingASCIIRulesa2d90zyoc6kw as toLowerCasePreservingASCIIRules,
  generateNonce3td15vdvbmmke as generateNonce,
  appendAlltwnjnu28pmtx as appendAll,
  putAll10o0q8e6mgnzr as putAll,
  GMTDate36bhedawynxlf as GMTDate,
  Pipeline2vw6c5wpzxajt as Pipeline,
} from './ktor-ktor-utils.mjs';
import {
  Events63tfxre48w4z as Events,
  EventDefinition1fymk8xrdelhn as EventDefinition,
} from './ktor-ktor-events.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  readRemaining1kbpbgdrq25q1 as readRemaining,
  ByteReadChannel1cb89sbyipkce as ByteReadChannel_0,
  writer1eia5its2a1fh as writer,
  Companion_getInstance25751un9ltd4f as Companion_getInstance,
  ioDispatcher3b9pa3x0duop as ioDispatcher,
  MalformedInputExceptionbvc6h5ij0ias as MalformedInputException,
  copyTo1e8cxw3cmqjst as copyTo,
  canceldn4b3cdqcfny as cancel_3,
  invokeOnCompletion1ziuxzoag0iwj as invokeOnCompletion,
  toByteArray1nbmiiav9igm0 as toByteArray,
  readText3frapgncbqrcg as readText,
  Charsets_getInstance3jooo7e4x0j2x as Charsets_getInstance,
  get_name2f11g4r0d5pxp as get_name,
  readText27783kyxjxi1g as readText_0,
  ByteChannel3cxdguezl3lu7 as ByteChannel,
  decode1t43jmuxrxpmo as decode,
  get_ByteArrayPool3f7yrgvqxz9ct as get_ByteArrayPool,
  readAvailable2yaaricqompas as readAvailable,
  writeFullyuc6cd2hh6ex3 as writeFully,
  close3semq7pafb42g as close,
  writeFully359t6q8kam2g5 as writeFully_0,
} from './ktor-ktor-io.mjs';
import {
  NullBody_instanceyfq32eqie90j as NullBody_instance,
  contentLength2suzxu1lzutku as contentLength,
  WriteChannelContent1d7f40hsfcaxg as WriteChannelContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  NoContent1bdx48poqrifq as NoContent,
  ProtocolUpgradexnnpt2xliy8g as ProtocolUpgrade,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ContentWrapper3n9gdymgnbto9 as ContentWrapper,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  HttpHeaders_getInstance3m47m69p49qfb as HttpHeaders_getInstance,
  UnsafeHeaderException3ncvrrp48xjzq as UnsafeHeaderException,
  Application_getInstance17ubdrb0i0ohu as Application_getInstance,
  contentType2zzm38yxo3syt as contentType,
  Text_getInstancecnzpw4phsgym as Text_getInstance,
  TextContent1rb6ftlpvl1d2 as TextContent,
  Companion_getInstance3eu9tsw6r4gc4 as Companion_getInstance_0,
  MultiPart_getInstance1k6b6wx1k1sjr as MultiPart_getInstance,
  MultiPartData57syw40llxls as MultiPartData,
  HttpStatusCode3o1wkms10pg4k as HttpStatusCode,
  charset1dribv3ku48b1 as charset,
  withCharset27k3t3dvzhi4n as withCharset,
  charset3qqtyytkmxogi as charset_0,
  Companion_getInstance2192nrpo98q6y as Companion_getInstance_1,
  get_authority2s3hk87lssumy as get_authority,
  takeFrom3rd40szpqy350 as takeFrom,
  isSecurex1qiiavqi0xu as isSecure,
  get_authorityakhc3pgcrb9j as get_authority_0,
  Companion_getInstance1pptfj8vjmgsz as Companion_getInstance_2,
  NullBody1903zz7riiwr0 as NullBody,
  hostIsIp3bb88hkcut0h0 as hostIsIp,
  clone36ocpwr7g14r5 as clone,
  parseClientCookiesHeadert8p20xfeewy as parseClientCookiesHeader,
  CookieEncoding_RAW_getInstance970baffcwmo8 as CookieEncoding_RAW_getInstance,
  Cookie2mi3e4peeulg2 as Cookie,
  setCookie224ax7zijawy2 as setCookie,
  renderCookieHeader384jfdw23qi6g as renderCookieHeader,
  HeadersBuilder3h7sn3kkvu98m as HeadersBuilder,
  isWebsocket1w1xog9vfgwm1 as isWebsocket,
  Companion_getInstancehe53gw4v5mqu as Companion_getInstance_3,
  URLBuilder2mz8zkz4u9ray as URLBuilder,
  takeFromkqlcz7c6dx2r as takeFrom_0,
  Companion_getInstance37paccmlttr9s as Companion_getInstance_4,
  headersOf2tgdoojg8tifn as headersOf,
  Companion_getInstance222gjh8cwt6g7 as Companion_getInstance_5,
  get_supportsRequestBodyjdtitrt33hir as get_supportsRequestBody,
  isEmpty1yq29t926r0va as isEmpty,
} from './ktor-ktor-http.mjs';
import {
  readByteArray1ri21h2rciakw as readByteArray,
  Source1shr0ps16u4p4 as Source,
  IOException1wyutdmfe71nu as IOException,
  Buffergs925ekssbch as Buffer,
} from './kotlinx-io-kotlinx-io-core.mjs';
import { CIOMultipartDataBase3o5u8w437tq5s as CIOMultipartDataBase } from './ktor-ktor-http-cio.mjs';
import {
  WebSocketSessionzi1ianvyj32u as WebSocketSession,
  DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession,
  parseWebSocketExtensionszyo25w86ylog as parseWebSocketExtensions,
  WebSocketExtensionsConfig3sf1f7u7xi63m as WebSocketExtensionsConfig,
  WebSocketChannelsConfig1qogztyrywmj9 as WebSocketChannelsConfig,
  Companion_getInstance27kujspvp4jub as Companion_getInstance_6,
  DefaultWebSocketSessionmehckluw85jl as DefaultWebSocketSession_0,
  WebSocketExtensionixqq2y77p4e0 as WebSocketExtension,
  Companion_getInstanceo8cazic5dguk as Companion_getInstance_7,
  Codes_CLOSED_ABNORMALLY_getInstance35h8511ldg1ec as Codes_CLOSED_ABNORMALLY_getInstance,
  Text3e6ukp9joohql as Text,
  Binary3tlzyfojm51s4 as Binary,
  CloseReason10cphaqpp3ct7 as CloseReason,
  Close3tx65evcwi73t as Close,
  Codes_NORMAL_getInstance1njykag03saqj as Codes_NORMAL_getInstance,
  from3gpkuvfyl3bft as from,
  send3vgnni2smbra3 as send,
} from './ktor-ktor-websockets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class HttpClient {
  constructor(engine, userConfig) {
    return new.target.v84(engine, userConfig);
  }
  static v84(engine, userConfig) {
    userConfig = userConfig === VOID ? new HttpClientConfig() : userConfig;
    var $this = createThis(this);
    $this.a84_1 = engine;
    $this.b84_1 = userConfig;
    $this.c84_1 = false;
    $this.d84_1 = atomic$boolean$1(false);
    $this.e84_1 = Job($this.a84_1.d1m().ae(Key_instance));
    $this.f84_1 = $this.a84_1.d1m().ep($this.e84_1);
    $this.g84_1 = new HttpRequestPipeline();
    $this.h84_1 = new HttpResponsePipeline();
    $this.i84_1 = new HttpSendPipeline();
    $this.j84_1 = new HttpReceivePipeline();
    $this.k84_1 = AttributesJsFn(true);
    $this.l84_1 = $this.a84_1.w84();
    $this.m84_1 = new Events();
    $this.n84_1 = new HttpClientConfig();
    if ($this.c84_1) {
      $this.e84_1.g1n(HttpClient$lambda($this));
    }
    $this.a84_1.x84($this);
    var tmp = Phases_getInstance_0().c85_1;
    $this.i84_1.z7f(tmp, HttpClient$slambda($this));
    // Inline function 'kotlin.with' call
    var $this$with = $this.b84_1;
    $this.n84_1.l85(get_HttpRequestLifecycle());
    $this.n84_1.l85(get_BodyProgress());
    $this.n84_1.l85(get_SaveBody());
    if ($this$with.i85_1) {
      $this.n84_1.m85('DefaultTransformers', HttpClient$lambda_0);
    }
    $this.n84_1.l85(Plugin_getInstance());
    $this.n84_1.l85(get_HttpCallValidator());
    if ($this$with.h85_1) {
      $this.n84_1.l85(get_HttpRedirect());
    }
    $this.n84_1.n85($this$with);
    if ($this$with.i85_1) {
      $this.n84_1.l85(get_HttpPlainText());
    }
    addDefaultResponseValidation($this.n84_1);
    $this.n84_1.x84($this);
    var tmp_0 = Phases_getInstance_1().o85_1;
    $this.h84_1.z7f(tmp_0, HttpClient$slambda_0($this));
    return $this;
  }
  static t85(engine, userConfig, manageEngine) {
    var $this = this.v84(engine, userConfig);
    $this.c84_1 = manageEngine;
    return $this;
  }
  d1m() {
    return this.f84_1;
  }
  *u85(builder, $completion) {
    this.m84_1.b7h(get_HttpRequestCreated(), builder);
    var tmp = yield* this.g84_1.u7f(builder, builder.y85_1, $completion);
    return tmp instanceof HttpClientCall ? tmp : THROW_CCE();
  }
  f7() {
    var success = this.d84_1.atomicfu$compareAndSet(false, true);
    if (!success)
      return Unit_instance;
    var installedFeatures = this.k84_1.g7a(get_PLUGIN_INSTALLED_LIST());
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = installedFeatures.n7a().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var plugin = installedFeatures.g7a(element instanceof AttributeKey ? element : THROW_CCE());
      if (isInterface(plugin, AutoCloseable)) {
        plugin.f7();
      }
    }
    this.e84_1.o1t();
    if (this.c84_1) {
      this.a84_1.f7();
    }
  }
  toString() {
    return 'HttpClient[' + toString(this.a84_1) + ']';
  }
}
class HttpClientConfig {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.d85_1 = LinkedHashMap.m7();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.e85_1 = LinkedHashMap.m7();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.f85_1 = LinkedHashMap.m7();
    var tmp_2 = this;
    tmp_2.g85_1 = HttpClientConfig$engineConfig$lambda;
    this.h85_1 = true;
    this.i85_1 = true;
    this.j85_1 = false;
    this.k85_1 = PlatformUtils_getInstance().t7b_1;
  }
  e86(plugin, configure) {
    var previousConfigBlock = this.e85_1.w4(plugin.j3());
    var tmp0 = this.e85_1;
    var tmp2 = plugin.j3();
    // Inline function 'kotlin.collections.set' call
    var value = HttpClientConfig$install$lambda_0(previousConfigBlock, configure);
    tmp0.b5(tmp2, value);
    installPlugin(this, plugin);
  }
  l85(plugin, configure, $super) {
    var tmp;
    if (configure === VOID) {
      tmp = HttpClientConfig$install$lambda;
    } else {
      tmp = configure;
    }
    configure = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.e86(plugin, configure);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.e86.call(this, plugin, configure);
    }
    return tmp_0;
  }
  m85(key, block) {
    // Inline function 'kotlin.collections.set' call
    this.f85_1.b5(key, block);
  }
  x84(client) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.d85_1.y4().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.apply' call
      element(client);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = this.f85_1.y4().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.apply' call
      element_0(client);
    }
  }
  n85(other) {
    this.h85_1 = other.h85_1;
    this.i85_1 = other.i85_1;
    this.j85_1 = other.j85_1;
    var tmp0 = this.d85_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map = other.d85_1;
    tmp0.d5(map);
    var tmp0_0 = this.e85_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_0 = other.e85_1;
    tmp0_0.d5(map_0);
    var tmp0_1 = this.f85_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_1 = other.f85_1;
    tmp0_1.d5(map_1);
  }
}
class HttpClientCall {
  constructor(client) {
    return new.target.l86(client);
  }
  static l86(client) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.o84_1 = client;
    $this.p84_1 = atomic$boolean$1(false);
    $this.s84_1 = false;
    return $this;
  }
  d1m() {
    return this.t84().d1m();
  }
  n86() {
    return this.m86().n86();
  }
  m86() {
    var tmp = this.q84_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('request');
    }
  }
  t84() {
    var tmp = this.r84_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('response');
    }
  }
  static h87(client, requestData, responseData) {
    Companion_getInstance_8();
    var $this = this.l86(client);
    $this.q84_1 = new DefaultHttpRequest($this, requestData);
    $this.r84_1 = new DefaultHttpResponse($this, responseData);
    $this.n86().l7a(Companion_getInstance_8().g87_1);
    var tmp = responseData.m87_1;
    if (!isInterface(tmp, ByteReadChannel)) {
      $this.n86().j7a(Companion_getInstance_8().g87_1, responseData.m87_1);
    }
    return $this;
  }
  o86() {
    return this.s84_1;
  }
  *p86($completion) {
    return this.t84().b87();
  }
  *q86(info, $completion) {
    try {
      if (instanceOf(this.t84(), info.n7g_1))
        return this.t84();
      if (!this.o86() && !get_isSaved(this.t84()) && !this.p84_1.atomicfu$compareAndSet(false, true)) {
        throw DoubleReceiveException.u87(this);
      }
      var tmp0_elvis_lhs = this.n86().h7a(Companion_getInstance_8().g87_1);
      var responseData = tmp0_elvis_lhs == null ? (yield* this.p86($completion)) : tmp0_elvis_lhs;
      var subject = new HttpResponseContainer(info, responseData);
      // Inline function 'kotlin.takeIf' call
      var this_0 = (yield* this.o84_1.h84_1.u7f(this, subject, $completion)).w87_1;
      var tmp;
      if (!equals(this_0, NullBody_instance)) {
        tmp = this_0;
      } else {
        tmp = null;
      }
      var result = tmp;
      if (!(result == null) && !instanceOf(result, info.n7g_1)) {
        var from = getKClassFromExpression(result);
        var to = info.n7g_1;
        throw NoTransformationFoundException.c88(this.t84(), from, to);
      }
      return result;
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        cancel_0(this.t84(), 'Receive failed', cause);
        throw cause;
      } else {
        throw $p;
      }
    }
  }
  toString() {
    return 'HttpClientCall[' + this.m86().v86().toString() + ', ' + this.t84().c87().toString() + ']';
  }
  u84(response) {
    this.r84_1 = response;
  }
}
class DelegatedCall extends HttpClientCall {
  constructor(client, originCall, responseContent, responseHeaders) {
    return new.target.k86(client, originCall, responseContent, responseHeaders);
  }
  static k86(client, originCall, responseContent, responseHeaders) {
    responseHeaders = responseHeaders === VOID ? originCall.t84().z7p() : responseHeaders;
    var $this = this.l86(client);
    $this.q84_1 = new DelegatedRequest($this, originCall.m86());
    $this.r84_1 = new DelegatedResponse($this, originCall.t84(), responseContent, responseHeaders);
    return $this;
  }
}
class HttpRequest {}
function get_coroutineContext() {
  return this.t86().d1m();
}
class DelegatedRequest {
  constructor(call, origin) {
    this.r86_1 = origin;
    this.s86_1 = call;
  }
  t86() {
    return this.s86_1;
  }
  d1m() {
    return this.r86_1.d1m();
  }
  u86() {
    return this.r86_1.u86();
  }
  v86() {
    return this.r86_1.v86();
  }
  n86() {
    return this.r86_1.n86();
  }
  s2f() {
    return this.r86_1.s2f();
  }
  z7p() {
    return this.r86_1.z7p();
  }
}
class HttpResponse {
  toString() {
    return 'HttpResponse[' + get_request(this).v86().toString() + ', ' + this.c87().toString() + ']';
  }
}
class DelegatedResponse extends HttpResponse {
  constructor(call, origin, content, headers) {
    headers = headers === VOID ? origin.z7p() : headers;
    super();
    this.w86_1 = call;
    this.x86_1 = origin;
    this.y86_1 = content;
    this.z86_1 = headers;
    this.a87_1 = this.x86_1.d1m();
  }
  t86() {
    return this.w86_1;
  }
  z7p() {
    return this.z86_1;
  }
  b87() {
    return this.y86_1(this.x86_1);
  }
  d1m() {
    return this.a87_1;
  }
  c87() {
    return this.x86_1.c87();
  }
  d87() {
    return this.x86_1.d87();
  }
  e87() {
    return this.x86_1.e87();
  }
  f87() {
    return this.x86_1.f87();
  }
}
class Companion {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'CustomResponse';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().hg();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().hg(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.g87_1 = new AttributeKey(name, tmp$ret$1);
  }
}
class DoubleReceiveException extends IllegalStateException {
  constructor(call) {
    return new.target.u87(call);
  }
  static u87(call) {
    var $this = this.m();
    captureStack($this, $this.t87_1);
    $this.s87_1 = 'Response already received: ' + call.toString();
    delete $this.message;
    return $this;
  }
  r() {
    return this.s87_1;
  }
  get message() {
    return this.r();
  }
}
class NoTransformationFoundException extends UnsupportedOperationException {
  constructor(response, from, to) {
    return new.target.c88(response, from, to);
  }
  static c88(response, from, to) {
    var $this = this.k9();
    captureStack($this, $this.b88_1);
    $this.a88_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).v86().toString() + '`\n        Response status `' + response.c87().toString() + '`\n        Response header `ContentType: ' + response.z7p().wi('Content-Type') + '` \n        Request header `Accept: ' + get_request(response).z7p().wi('Accept') + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
    delete $this.message;
    return $this;
  }
  r() {
    return this.a88_1;
  }
  get message() {
    return this.r();
  }
}
class SavedHttpCall extends HttpClientCall {
  constructor(client, request, response, responseBody) {
    return new.target.k88(client, request, response, responseBody);
  }
  static k88(client, request, response, responseBody) {
    var $this = this.l86(client);
    $this.i88_1 = responseBody;
    $this.q84_1 = new SavedHttpRequest($this, request);
    $this.r84_1 = new SavedHttpResponse($this, $this.i88_1, response);
    checkContentLength(contentLength(response), fromInt($this.i88_1.length), request.u86());
    $this.j88_1 = true;
    return $this;
  }
  o86() {
    return this.j88_1;
  }
}
class SavedHttpRequest {
  constructor(call, origin) {
    this.l88_1 = origin;
    this.m88_1 = call;
  }
  t86() {
    return this.m88_1;
  }
  d1m() {
    return this.l88_1.d1m();
  }
  u86() {
    return this.l88_1.u86();
  }
  v86() {
    return this.l88_1.v86();
  }
  n86() {
    return this.l88_1.n86();
  }
  s2f() {
    return this.l88_1.s2f();
  }
  z7p() {
    return this.l88_1.z7p();
  }
}
class SavedHttpResponse extends HttpResponse {
  constructor(call, body, origin) {
    super();
    this.n88_1 = call;
    this.o88_1 = body;
    this.p88_1 = origin.c87();
    this.q88_1 = origin.d87();
    this.r88_1 = origin.e87();
    this.s88_1 = origin.f87();
    this.t88_1 = origin.z7p();
    this.u88_1 = origin.d1m();
  }
  t86() {
    return this.n88_1;
  }
  c87() {
    return this.p88_1;
  }
  d87() {
    return this.q88_1;
  }
  e87() {
    return this.r88_1;
  }
  f87() {
    return this.s88_1;
  }
  z7p() {
    return this.t88_1;
  }
  d1m() {
    return this.u88_1;
  }
  b87() {
    return ByteReadChannel_0(this.o88_1);
  }
}
class UnsupportedContentTypeException extends IllegalStateException {
  constructor(content) {
    return new.target.z88(content);
  }
  static z88(content) {
    var $this = this.o('Failed to write body: ' + toString(getKClassFromExpression(content)));
    captureStack($this, $this.y88_1);
    return $this;
  }
}
class ProgressListener {}
class ObservableContent extends ReadChannelContent {
  constructor(delegate, callContext, listener) {
    super();
    this.c89_1 = delegate;
    this.d89_1 = callContext;
    this.e89_1 = listener;
  }
  q7v() {
    return this.c89_1.q7v();
  }
  r7v() {
    return this.c89_1.r7v();
  }
  z7p() {
    return this.c89_1.z7p();
  }
  t7v() {
    return observable(getContent(this, this.c89_1), this.d89_1, this.r7v(), this.e89_1);
  }
}
class HttpClientEngine {}
function get_supportedCapabilities() {
  return emptySet();
}
function install(client) {
  var tmp = Phases_getInstance_0().b85_1;
  client.i84_1.z7f(tmp, HttpClientEngine$install$slambda(client, this));
}
class ClientEngineClosedException extends IllegalStateException {
  constructor(cause) {
    return new.target.u89(cause);
  }
  static u89(cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.o('Client already closed');
    captureStack($this, $this.t89_1);
    $this.s89_1 = cause;
    delete $this.cause;
    return $this;
  }
  s() {
    return this.s89_1;
  }
  get cause() {
    return this.s();
  }
}
class HttpClientEngineBase {
  constructor(engineName) {
    this.a8a_1 = engineName;
    this.b8a_1 = atomic$boolean$1(false);
    var tmp = this;
    tmp.c8a_1 = lazy(HttpClientEngineBase$dispatcher$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.d8a_1 = lazy(HttpClientEngineBase$coroutineContext$delegate$lambda(this));
  }
  e8a() {
    var tmp0 = this.c8a_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('dispatcher', 1, tmp, HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v(), null);
    return tmp0.k3();
  }
  d1m() {
    var tmp0 = this.d8a_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coroutineContext', 1, tmp, HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr(), null);
    return tmp0.k3();
  }
  f7() {
    if (!this.b8a_1.atomicfu$compareAndSet(false, true))
      return Unit_instance;
    var tmp = this.d1m().ae(Key_instance);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var requestJob = tmp_0;
    requestJob.o1t();
  }
}
class HttpClientEngineCapability {}
class HttpClientEngineConfig {
  constructor() {
    this.w89_1 = 4;
    this.x89_1 = null;
    this.y89_1 = false;
    this.z89_1 = null;
  }
}
class Companion_0 {}
class KtorCallContextElement {
  constructor(callContext) {
    this.f8a_1 = callContext;
  }
  j3() {
    return Companion_instance_1;
  }
}
class AfterRenderHook {
  g8a(client, handler) {
    var observableContentPhase = new PipelinePhase('ObservableContent');
    client.g84_1.w7f(Phases_getInstance().k8a_1, observableContentPhase);
    client.g84_1.z7f(observableContentPhase, AfterRenderHook$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.g8a(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  }
}
class AfterReceiveHook {
  n8a(client, handler) {
    var tmp = Phases_getInstance_2().q8a_1;
    client.j84_1.z7f(tmp, AfterReceiveHook$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.n8a(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
  }
}
class ResponseException extends IllegalStateException {
  constructor(response, cachedResponseText) {
    return new.target.c8b(response, cachedResponseText);
  }
  static c8b(response, cachedResponseText) {
    var $this = this.o('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"');
    captureStack($this, $this.b8b_1);
    $this.a8b_1 = response;
    return $this;
  }
}
class RedirectResponseException extends ResponseException {
  constructor(response, cachedResponseText) {
    return new.target.k8b(response, cachedResponseText);
  }
  static k8b(response, cachedResponseText) {
    var $this = this.c8b(response, cachedResponseText);
    captureStack($this, $this.j8b_1);
    $this.i8b_1 = 'Unhandled redirect: ' + response.t86().m86().u86().k7q_1 + ' ' + response.t86().m86().v86().toString() + '. ' + ('Status: ' + response.c87().toString() + '. Text: "' + cachedResponseText + '"');
    delete $this.message;
    return $this;
  }
  r() {
    return this.i8b_1;
  }
  get message() {
    return this.r();
  }
}
class ClientRequestException extends ResponseException {
  constructor(response, cachedResponseText) {
    return new.target.s8b(response, cachedResponseText);
  }
  static s8b(response, cachedResponseText) {
    var $this = this.c8b(response, cachedResponseText);
    captureStack($this, $this.r8b_1);
    $this.q8b_1 = 'Client request(' + response.t86().m86().u86().k7q_1 + ' ' + response.t86().m86().v86().toString() + ') ' + ('invalid: ' + response.c87().toString() + '. Text: "' + cachedResponseText + '"');
    delete $this.message;
    return $this;
  }
  r() {
    return this.q8b_1;
  }
  get message() {
    return this.r();
  }
}
class ServerResponseException extends ResponseException {
  constructor(response, cachedResponseText) {
    return new.target.a8c(response, cachedResponseText);
  }
  static a8c(response, cachedResponseText) {
    var $this = this.c8b(response, cachedResponseText);
    captureStack($this, $this.z8b_1);
    $this.y8b_1 = 'Server error(' + response.t86().m86().u86().k7q_1 + ' ' + response.t86().m86().v86().toString() + ': ' + (response.c87().toString() + '. Text: "' + cachedResponseText + '"');
    delete $this.message;
    return $this;
  }
  r() {
    return this.y8b_1;
  }
  get message() {
    return this.r();
  }
}
class defaultTransformers$1$content$1 extends ByteArrayContent {
  constructor($contentType, $body, $box) {
    if ($box === VOID)
      $box = {};
    $box.i8c_1 = $body;
    super($box);
    var tmp = this;
    tmp.g8c_1 = $contentType == null ? Application_getInstance().f7i_1 : $contentType;
    this.h8c_1 = fromInt($body.length);
  }
  q7v() {
    return this.g8c_1;
  }
  r7v() {
    return this.h8c_1;
  }
  x7v() {
    return this.i8c_1;
  }
}
class defaultTransformers$1$content$2 extends ReadChannelContent {
  constructor($this_intercept, $contentType, $body, $box) {
    if ($box === VOID)
      $box = {};
    $box.m8c_1 = $body;
    super($box);
    var tmp = this;
    var tmp0_safe_receiver = $this_intercept.v7f_1.x85_1.wi('Content-Length');
    tmp.k8c_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
    var tmp_0 = this;
    tmp_0.l8c_1 = $contentType == null ? Application_getInstance().f7i_1 : $contentType;
  }
  r7v() {
    return this.k8c_1;
  }
  q7v() {
    return this.l8c_1;
  }
  t7v() {
    return this.m8c_1;
  }
}
class HttpCallValidatorConfig {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.b8c_1 = ArrayList.p2();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.c8c_1 = ArrayList.p2();
    this.d8c_1 = true;
  }
  e8c(block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.b8c_1.d2(block);
  }
}
class ExceptionHandlerWrapper {}
class RequestExceptionHandlerWrapper {}
class RequestError {
  n8c(client, handler) {
    var tmp = Phases_getInstance().h8a_1;
    client.g84_1.z7f(tmp, RequestError$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.n8c(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  }
}
class ReceiveError {
  n8c(client, handler) {
    var BeforeReceive = new PipelinePhase('BeforeReceive');
    client.h84_1.y7f(Phases_getInstance_1().o85_1, BeforeReceive);
    client.h84_1.z7f(BeforeReceive, ReceiveError$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.n8c(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  }
}
class HttpRequest$1 {
  constructor($builder) {
    this.x8c_1 = $builder;
    this.t8c_1 = $builder.w85_1;
    this.u8c_1 = $builder.v85_1.j7e();
    this.v8c_1 = $builder.a86_1;
    this.w8c_1 = $builder.x85_1.j7e();
  }
  t86() {
    // Inline function 'kotlin.error' call
    var message = 'Call is not initialized';
    throw IllegalStateException.o(toString(message));
  }
  u86() {
    return this.t8c_1;
  }
  v86() {
    return this.u8c_1;
  }
  n86() {
    return this.v8c_1;
  }
  z7p() {
    return this.w8c_1;
  }
  s2f() {
    var tmp = this.x8c_1.y85_1;
    var tmp0_elvis_lhs = tmp instanceof OutgoingContent ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString(this.x8c_1.y85_1);
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
}
class HttpPlainTextConfig {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.y8c_1 = LinkedHashSet.v2();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.z8c_1 = LinkedHashMap.m7();
    this.a8d_1 = null;
    this.b8d_1 = Charsets_getInstance().c79_1;
  }
}
class RenderRequestHook {
  c8d(client, handler) {
    var tmp = Phases_getInstance().k8a_1;
    client.g84_1.z7f(tmp, RenderRequestHook$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.c8d(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.e8d_1 = function_0;
  }
  pj(a, b) {
    return this.e8d_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.e8d_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class HttpRedirectConfig {
  constructor() {
    this.f8d_1 = true;
    this.g8d_1 = false;
  }
}
class SetupRequestContext {
  h8d(client, handler) {
    var tmp = Phases_getInstance().h8a_1;
    client.g84_1.z7f(tmp, SetupRequestContext$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.h8d(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  }
}
class HttpRetryEventData {
  constructor(request, retryCount, response, cause) {
    this.i8d_1 = request;
    this.j8d_1 = retryCount;
    this.k8d_1 = response;
    this.l8d_1 = cause;
  }
}
class HttpRequestRetryConfig {
  constructor() {
    var tmp = this;
    tmp.s8d_1 = HttpRequestRetryConfig$delay$slambda();
    var tmp_0 = this;
    tmp_0.t8d_1 = HttpRequestRetryConfig$modifyRequest$lambda;
    this.u8d_1 = 0;
    this.v8d(3);
    this.w8d();
  }
  x8d() {
    var tmp = this.p8d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('shouldRetry');
    }
  }
  y8d() {
    var tmp = this.q8d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('shouldRetryOnException');
    }
  }
  z8d() {
    var tmp = this.r8d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('delayMillis');
    }
  }
  a8e(maxRetries, block) {
    if (!(maxRetries === -1))
      this.u8d_1 = maxRetries;
    this.p8d_1 = block;
  }
  b8e(maxRetries, block) {
    if (!(maxRetries === -1))
      this.u8d_1 = maxRetries;
    this.q8d_1 = block;
  }
  c8e(maxRetries, retryOnTimeout) {
    this.b8e(maxRetries, HttpRequestRetryConfig$retryOnException$lambda(retryOnTimeout));
  }
  d8e(maxRetries, retryOnTimeout, $super) {
    maxRetries = maxRetries === VOID ? -1 : maxRetries;
    retryOnTimeout = retryOnTimeout === VOID ? false : retryOnTimeout;
    var tmp;
    if ($super === VOID) {
      this.c8e(maxRetries, retryOnTimeout);
      tmp = Unit_instance;
    } else {
      tmp = $super.c8e.call(this, maxRetries, retryOnTimeout);
    }
    return tmp;
  }
  e8e(maxRetries) {
    this.a8e(maxRetries, HttpRequestRetryConfig$retryOnServerErrors$lambda);
  }
  v8d(maxRetries) {
    this.e8e(maxRetries);
    this.d8e(maxRetries);
  }
  f8e(respectRetryAfterHeader, block) {
    var tmp = this;
    tmp.r8d_1 = HttpRequestRetryConfig$delayMillis$lambda(respectRetryAfterHeader, block);
  }
  g8e(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader) {
    // Inline function 'kotlin.check' call
    if (!(base > 0)) {
      throw IllegalStateException.o('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(compare(baseDelayMs, new Long(0, 0)) > 0)) {
      throw IllegalStateException.o('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(compare(maxDelayMs, new Long(0, 0)) > 0)) {
      throw IllegalStateException.o('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(compare(randomizationMs, new Long(0, 0)) >= 0)) {
      throw IllegalStateException.o('Check failed.');
    }
    this.f8e(respectRetryAfterHeader, HttpRequestRetryConfig$exponentialDelay$lambda(base, baseDelayMs, maxDelayMs, this, randomizationMs));
  }
  w8d(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader, $super) {
    base = base === VOID ? 2.0 : base;
    baseDelayMs = baseDelayMs === VOID ? new Long(1000, 0) : baseDelayMs;
    maxDelayMs = maxDelayMs === VOID ? new Long(60000, 0) : maxDelayMs;
    randomizationMs = randomizationMs === VOID ? new Long(1000, 0) : randomizationMs;
    respectRetryAfterHeader = respectRetryAfterHeader === VOID ? true : respectRetryAfterHeader;
    var tmp;
    if ($super === VOID) {
      this.g8e(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
      tmp = Unit_instance;
    } else {
      tmp = $super.g8e.call(this, base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
    }
    return tmp;
  }
}
class HttpRetryShouldRetryContext {
  constructor(retryCount) {
    this.h8e_1 = retryCount;
  }
}
class HttpRetryDelayContext {
  constructor(request, response, cause) {
    this.m8d_1 = request;
    this.n8d_1 = response;
    this.o8d_1 = cause;
  }
}
class HttpRetryModifyRequestContext {
  constructor(request, response, cause, retryCount) {
    this.i8e_1 = request;
    this.j8e_1 = response;
    this.k8e_1 = cause;
    this.l8e_1 = retryCount;
  }
}
class Config {
  constructor() {
    this.r8e_1 = 20;
  }
}
class Plugin {
  constructor() {
    Plugin_instance = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'HttpSend';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(HttpSend);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(HttpSend), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.s8e_1 = new AttributeKey(name, tmp$ret$1);
  }
  j3() {
    return this.s8e_1;
  }
  t8e(block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    block(this_0);
    var config = this_0;
    return new HttpSend(config.r8e_1);
  }
  c86(block) {
    return this.t8e(block);
  }
  u8e(plugin, scope) {
    var tmp = Phases_getInstance().l8a_1;
    scope.g84_1.z7f(tmp, HttpSend$Plugin$install$slambda(plugin, scope));
  }
  d86(plugin, scope) {
    return this.u8e(plugin instanceof HttpSend ? plugin : THROW_CCE(), scope);
  }
}
class InterceptedSender {
  constructor(interceptor, nextSender) {
    this.v8e_1 = interceptor;
    this.w8e_1 = nextSender;
  }
  *q8e(requestBuilder, $completion) {
    return yield* this.v8e_1(this.w8e_1, requestBuilder, $completion);
  }
}
class DefaultSender {
  constructor(maxSendCount, client) {
    this.x8e_1 = maxSendCount;
    this.y8e_1 = client;
    this.z8e_1 = 0;
    this.a8f_1 = null;
  }
  *q8e(requestBuilder, $completion) {
    var tmp0_safe_receiver = this.a8f_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel(tmp0_safe_receiver);
    }
    if (this.z8e_1 >= this.x8e_1) {
      throw SendCountExceedException.f8f('Max send count ' + this.x8e_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
    }
    this.z8e_1 = this.z8e_1 + 1 | 0;
    var sendResult = yield* this.y8e_1.i84_1.u7f(requestBuilder, requestBuilder.y85_1, $completion);
    var tmp1_elvis_lhs = sendResult instanceof HttpClientCall ? sendResult : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
      throw IllegalStateException.o(toString(message));
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var call = tmp;
    this.a8f_1 = call;
    return call;
  }
}
class HttpSend {
  constructor(maxSendCount) {
    Plugin_getInstance();
    maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
    this.o8e_1 = maxSendCount;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.p8e_1 = ArrayList.p2();
  }
  g8f(block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.p8e_1.d2(block);
  }
}
class SendCountExceedException extends IllegalStateException {
  constructor(message) {
    return new.target.f8f(message);
  }
  static f8f(message) {
    var $this = this.o(message);
    captureStack($this, $this.e8f_1);
    return $this;
  }
}
class HttpTimeoutCapability {
  toString() {
    return 'HttpTimeoutCapability';
  }
  hashCode() {
    return 2058496954;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpTimeoutCapability))
      return false;
    return true;
  }
}
class HttpRequestTimeoutException extends IOException {}
class SaveBodyPluginConfig {
  constructor() {
    this.h8f_1 = false;
  }
}
class HookHandler {
  constructor(hook, handler) {
    this.i8f_1 = hook;
    this.j8f_1 = handler;
  }
  x84(client) {
    this.i8f_1.m8a(client, this.j8f_1);
  }
}
class ClientPluginBuilder {
  constructor(key, client, pluginConfig) {
    this.r8a_1 = key;
    this.s8a_1 = client;
    this.t8a_1 = pluginConfig;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.u8a_1 = ArrayList.p2();
    var tmp_0 = this;
    tmp_0.v8a_1 = ClientPluginBuilder$onClose$lambda;
  }
  m8e(block) {
    this.w8a(RequestHook_instance, block);
  }
  d8d(block) {
    this.w8a(TransformResponseBodyHook_instance, block);
  }
  w8a(hook, handler) {
    this.u8a_1.d2(new HookHandler(hook, handler));
  }
}
class ClientPluginInstance {
  constructor(key, config, body) {
    this.k8f_1 = key;
    this.l8f_1 = config;
    this.m8f_1 = body;
    var tmp = this;
    tmp.n8f_1 = ClientPluginInstance$onClose$lambda;
  }
  x84(scope) {
    var tmp0 = new ClientPluginBuilder(this.k8f_1, scope, this.l8f_1);
    // Inline function 'kotlin.apply' call
    this.m8f_1(tmp0);
    var pluginBuilder = tmp0;
    this.n8f_1 = pluginBuilder.v8a_1;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = pluginBuilder.u8a_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      element.x84(scope);
    }
  }
  f7() {
    this.n8f_1();
  }
}
class SetupRequest {
  o8f(client, handler) {
    var tmp = Phases_getInstance().h8a_1;
    client.g84_1.z7f(tmp, SetupRequest$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.o8f(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
  }
}
class Sender {
  constructor(httpSendSender, coroutineContext) {
    this.q8c_1 = httpSendSender;
    this.r8c_1 = coroutineContext;
  }
  d1m() {
    return this.r8c_1;
  }
  *s8c(requestBuilder, $completion) {
    return yield* this.q8c_1.q8e(requestBuilder, $completion);
  }
}
class Send {
  p8f(client, handler) {
    var tmp = plugin(client, Plugin_getInstance());
    tmp.g8f(Send$install$slambda(handler, client));
  }
  m8a(client, handler) {
    return this.p8f(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  }
}
class ClientPluginImpl {
  constructor(name, createConfiguration, body) {
    this.q8f_1 = createConfiguration;
    this.r8f_1 = body;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(ClientPluginInstance);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(ClientPluginInstance), arrayOf([createInvariantKTypeProjection(createKType(createKTypeParameter('PluginConfigT', arrayOf([createKType(PrimitiveClasses_getInstance().hg(), arrayOf([]), false)]), 'invariant', false, 'io.ktor.client.plugins.api.ClientPluginImpl'), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.s8f_1 = new AttributeKey(name, tmp$ret$1);
  }
  j3() {
    return this.s8f_1;
  }
  t8f(block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.q8f_1();
    block(this_0);
    var config = this_0;
    return new ClientPluginInstance(this.s8f_1, config, this.r8f_1);
  }
  c86(block) {
    return this.t8f(block);
  }
  u8f(plugin, scope) {
    plugin.x84(scope);
  }
  d86(plugin, scope) {
    return this.u8f(plugin instanceof ClientPluginInstance ? plugin : THROW_CCE(), scope);
  }
}
class TransformResponseBodyContext {}
class OnRequestContext {}
class RequestHook {
  v8f(client, handler) {
    var tmp = Phases_getInstance().i8a_1;
    client.g84_1.z7f(tmp, RequestHook$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.v8f(client, (!(handler == null) ? isSuspendFunction(handler, 3) : false) ? handler : THROW_CCE());
  }
}
class TransformResponseBodyHook {
  w8f(client, handler) {
    var tmp = Phases_getInstance_1().q85_1;
    client.h84_1.z7f(tmp, TransformResponseBodyHook$install$slambda(handler));
  }
  m8a(client, handler) {
    return this.w8f(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
  }
}
class CookieWithTimestamp {
  constructor(cookie, createdAt) {
    this.x8f_1 = cookie;
    this.y8f_1 = createdAt;
  }
  jm() {
    return this.x8f_1;
  }
  km() {
    return this.y8f_1;
  }
  toString() {
    return 'CookieWithTimestamp(cookie=' + this.x8f_1.toString() + ', createdAt=' + this.y8f_1.toString() + ')';
  }
  hashCode() {
    var result = this.x8f_1.hashCode();
    result = imul(result, 31) + this.y8f_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CookieWithTimestamp))
      return false;
    if (!this.x8f_1.equals(other.x8f_1))
      return false;
    if (!equalsLong(this.y8f_1, other.y8f_1))
      return false;
    return true;
  }
}
class AcceptAllCookiesStorage {
  constructor(clock) {
    var tmp;
    if (clock === VOID) {
      tmp = AcceptAllCookiesStorage$_init_$lambda_odelxi;
    } else {
      tmp = clock;
    }
    clock = tmp;
    this.z8f_1 = clock;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.a8g_1 = ArrayList.p2();
    this.b8g_1 = atomic$long$1(new Long(0, 0));
    this.c8g_1 = Mutex();
  }
  *d8g(requestUrl, $completion) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this.c8g_1;
    yield* this_0.y2a(null, $completion);
    var tmp;
    try {
      var now = this.z8f_1();
      if (compare(now, this.b8g_1.kotlinx$atomicfu$value) >= 0) {
        cleanup(this, now);
      }
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = this.a8g_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (matches(element.x8f_1, requestUrl)) {
          destination.d2(element);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
      var _iterator__ex2g4s_0 = destination.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var item = _iterator__ex2g4s_0.r1();
        var tmp$ret$7 = item.x8f_1;
        destination_0.d2(tmp$ret$7);
      }
      var cookies = destination_0;
      tmp = cookies;
    }finally {
      this_0.k2a(null);
    }
    return tmp;
  }
  *e8g(requestUrl, cookie, $completion) {
    // Inline function 'kotlin.with' call
    if (isBlank(cookie.z7j_1))
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this.c8g_1;
    yield* this_0.y2a(null, $completion);
    var tmp;
    try {
      removeAll(this.a8g_1, AcceptAllCookiesStorage$addCookie$lambda(cookie, requestUrl));
      var createdAt = this.z8f_1();
      this.a8g_1.d2(new CookieWithTimestamp(fillDefaults(cookie, requestUrl), createdAt));
      var tmp0_safe_receiver = maxAgeOrExpires(this, cookie, createdAt);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        if (compare(this.b8g_1.kotlinx$atomicfu$value, tmp0_safe_receiver) > 0) {
          this.b8g_1.kotlinx$atomicfu$value = tmp0_safe_receiver;
        }
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }finally {
      this_0.k2a(null);
    }
    return Unit_instance;
  }
  f7() {
  }
}
class Config_0 {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.l8g_1 = ArrayList.p2();
    this.m8g_1 = new AcceptAllCookiesStorage();
  }
  n8g() {
    return new HttpCookies(this.m8g_1, this.l8g_1);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'HttpCookies';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(HttpCookies);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(HttpCookies), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.o8g_1 = new AttributeKey(name, tmp$ret$1);
  }
  p8g(block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_0();
    block(this_0);
    return this_0.n8g();
  }
  c86(block) {
    return this.p8g(block);
  }
  j3() {
    return this.o8g_1;
  }
  q8g(plugin, scope) {
    var tmp = Phases_getInstance().i8a_1;
    scope.g84_1.z7f(tmp, HttpCookies$Companion$install$slambda(plugin));
    var tmp_0 = Phases_getInstance_0().z84_1;
    scope.i84_1.z7f(tmp_0, HttpCookies$Companion$install$slambda_0(plugin));
    var tmp_1 = Phases_getInstance_2().p8a_1;
    scope.j84_1.z7f(tmp_1, HttpCookies$Companion$install$slambda_1(plugin));
  }
  d86(plugin, scope) {
    return this.q8g(plugin instanceof HttpCookies ? plugin : THROW_CCE(), scope);
  }
}
class HttpCookies {
  constructor(storage, defaults) {
    Companion_getInstance_10();
    this.f8g_1 = storage;
    this.g8g_1 = defaults;
    var tmp = this;
    var tmp_0 = GlobalScope_instance;
    var tmp_1 = Dispatchers_getInstance().d1u_1;
    tmp.h8g_1 = launch(tmp_0, tmp_1, VOID, HttpCookies$initializer$slambda(this));
  }
  *d8g(requestUrl, $completion) {
    yield* this.h8g_1.k1n($completion);
    return yield* this.f8g_1.d8g(requestUrl, $completion);
  }
  *i8g(builder, $completion) {
    // Inline function 'kotlin.with' call
    var url = clone(builder.v85_1).j7e();
    var tmp0_safe_receiver = builder.x85_1.wi('Cookie');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      get_LOGGER_7().z7g('Saving cookie ' + tmp0_safe_receiver + ' for ' + builder.v85_1.toString());
      // Inline function 'kotlin.collections.map' call
      var this_0 = parseClientCookiesHeader(tmp0_safe_receiver);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(this_0.s2());
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = this_0.i3().p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        // Inline function 'kotlin.collections.component1' call
        var name = item.j3();
        // Inline function 'kotlin.collections.component2' call
        var encodedValue = item.k3();
        var tmp$ret$7 = new Cookie(name, encodedValue, CookieEncoding_RAW_getInstance());
        destination.d2(tmp$ret$7);
      }
      tmp = destination;
    }
    var cookies = tmp;
    var tmp_0;
    if (cookies == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = cookies.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element = _iterator__ex2g4s_0.r1();
        yield* this.f8g_1.e8g(url, element, $completion);
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  }
  *j8g(builder, $completion) {
    var cookies = yield* this.d8g(clone(builder.v85_1).j7e(), $completion);
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!cookies.n1()) {
      var cookieHeader = renderClientCookies(cookies);
      builder.x85_1.e7c('Cookie', cookieHeader);
      get_LOGGER_7().z7g('Sending cookie ' + cookieHeader + ' for ' + builder.v85_1.toString());
    } else {
      builder.x85_1.i7c('Cookie');
    }
    return Unit_instance;
  }
  *k8g(response, $completion) {
    var url = get_request(response).v86();
    var tmp0_safe_receiver = response.z7p().y7b('Set-Cookie');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0_safe_receiver.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        get_LOGGER_7().z7g('Received cookie ' + element + ' in response for ' + response.t86().m86().v86().toString());
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = setCookie(response).p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      yield* this.f8g_1.e8g(url, element_0, $completion);
    }
    return Unit_instance;
  }
  f7() {
    this.f8g_1.f7();
  }
}
class SSECapability {
  toString() {
    return 'SSECapability';
  }
  hashCode() {
    return -177755299;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SSECapability))
      return false;
    return true;
  }
}
class DefaultClientWebSocketSession {
  constructor(call, delegate) {
    this.r8g_1 = delegate;
    this.s8g_1 = call;
  }
  *v7z(frame, $completion) {
    yield* this.r8g_1.v7z(frame, $completion);
    return Unit_instance;
  }
  *f77($completion) {
    yield* this.r8g_1.f77($completion);
    return Unit_instance;
  }
  r7z(_set____db54di) {
    this.r8g_1.r7z(_set____db54di);
  }
  s7z() {
    return this.r8g_1.s7z();
  }
  t7z() {
    return this.r8g_1.t7z();
  }
  u7z() {
    return this.r8g_1.u7z();
  }
  d1m() {
    return this.r8g_1.d1m();
  }
  q7z(negotiatedExtensions) {
    this.r8g_1.q7z(negotiatedExtensions);
  }
}
class DelegatingClientWebSocketSession {
  constructor(call, session) {
    this.t8g_1 = session;
    this.u8g_1 = call;
  }
  *v7z(frame, $completion) {
    yield* this.t8g_1.v7z(frame, $completion);
    return Unit_instance;
  }
  *f77($completion) {
    yield* this.t8g_1.f77($completion);
    return Unit_instance;
  }
  r7z(_set____db54di) {
    this.t8g_1.r7z(_set____db54di);
  }
  s7z() {
    return this.t8g_1.s7z();
  }
  t7z() {
    return this.t8g_1.t7z();
  }
  u7z() {
    return this.t8g_1.u7z();
  }
  d1m() {
    return this.t8g_1.d1m();
  }
}
class ClientUpgradeContent extends NoContent {
  constructor() {
    super();
    var tmp = this;
    tmp.a8i_1 = lazy(ClientUpgradeContent$content$delegate$lambda);
  }
}
class WebSocketContent extends ClientUpgradeContent {
  constructor() {
    super();
    var tmp = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    var nonce = generateNonce(16);
    this_0.m1(Default_getInstance_0().kq(nonce));
    tmp.x8g_1 = this_0.toString();
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new HeadersBuilder();
    this_1.g7c('Upgrade', 'websocket');
    this_1.g7c('Connection', 'Upgrade');
    this_1.g7c('Sec-WebSocket-Key', this.x8g_1);
    this_1.g7c('Sec-WebSocket-Version', '13');
    tmp_0.y8g_1 = this_1.j7e();
  }
  z7p() {
    return this.y8g_1;
  }
  toString() {
    return 'WebSocketContent';
  }
}
class Config_1 {
  constructor() {
    this.l8h_1 = new WebSocketExtensionsConfig();
    this.m8h_1 = new WebSocketChannelsConfig();
    this.n8h_1 = new Long(0, 0);
    this.o8h_1 = new Long(2147483647, 0);
    this.p8h_1 = null;
  }
}
class Plugin_0 {
  constructor() {
    Plugin_instance_0 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'Websocket';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(WebSockets);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(WebSockets), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.q8h_1 = new AttributeKey(name, tmp$ret$1);
  }
  j3() {
    return this.q8h_1;
  }
  r8h(block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_1();
    block(this_0);
    var config = this_0;
    return new WebSockets(config.n8h_1, config.o8h_1, config.l8h_1, config.p8h_1, config.m8h_1);
  }
  c86(block) {
    return this.r8h(block);
  }
  s8h(plugin, scope) {
    var extensionsSupported = scope.a84_1.m89().w2(WebSocketExtensionsCapability_instance);
    var tmp = Phases_getInstance().k8a_1;
    scope.g84_1.z7f(tmp, WebSockets$Plugin$install$slambda(extensionsSupported, plugin));
    var tmp_0 = Phases_getInstance_1().q85_1;
    scope.h84_1.z7f(tmp_0, WebSockets$Plugin$install$slambda_0(plugin, extensionsSupported));
  }
  d86(plugin, scope) {
    return this.s8h(plugin instanceof WebSockets ? plugin : THROW_CCE(), scope);
  }
}
class WebSockets {
  constructor(pingIntervalMillis, maxFrameSize, extensionsConfig, contentConverter, channelsConfig) {
    Plugin_getInstance_0();
    contentConverter = contentConverter === VOID ? null : contentConverter;
    channelsConfig = channelsConfig === VOID ? Companion_getInstance_6().w7z_1 : channelsConfig;
    this.f8h_1 = pingIntervalMillis;
    this.g8h_1 = maxFrameSize;
    this.h8h_1 = extensionsConfig;
    this.i8h_1 = contentConverter;
    this.j8h_1 = channelsConfig;
  }
  k8h(session) {
    if (isInterface(session, DefaultWebSocketSession))
      return session;
    // Inline function 'kotlin.Long.times' call
    var this_0 = this.f8h_1;
    var timeoutMillis = multiply(this_0, fromInt(2));
    // Inline function 'kotlin.also' call
    var this_1 = DefaultWebSocketSession_0(session, this.f8h_1, timeoutMillis, this.j8h_1);
    this_1.r7z(this.g8h_1);
    return this_1;
  }
}
class WebSocketExtensionsCapability {
  toString() {
    return 'WebSocketExtensionsCapability';
  }
  hashCode() {
    return 806573237;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WebSocketExtensionsCapability))
      return false;
    return true;
  }
}
class WebSocketCapability {
  toString() {
    return 'WebSocketCapability';
  }
  hashCode() {
    return -1146563391;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WebSocketCapability))
      return false;
    return true;
  }
}
class WebSocketException extends IllegalStateException {
  constructor(message, cause) {
    return new.target.t8h(message, cause);
  }
  static t8h(message, cause) {
    var $this = this.q(message, cause);
    captureStack($this, $this.d8h_1);
    return $this;
  }
  static e8h(message) {
    return this.t8h(message, null);
  }
}
class DefaultHttpRequest {
  constructor(call, data) {
    this.b8i_1 = call;
    this.c8i_1 = data.g89_1;
    this.d8i_1 = data.f89_1;
    this.e8i_1 = data.i89_1;
    this.f8i_1 = data.h89_1;
    this.g8i_1 = data.k89_1;
  }
  t86() {
    return this.b8i_1;
  }
  d1m() {
    return this.t86().d1m();
  }
  u86() {
    return this.c8i_1;
  }
  v86() {
    return this.d8i_1;
  }
  s2f() {
    return this.e8i_1;
  }
  z7p() {
    return this.f8i_1;
  }
  n86() {
    return this.g8i_1;
  }
}
class Companion_2 {}
class HttpRequestBuilder {
  constructor() {
    this.v85_1 = new URLBuilder();
    this.w85_1 = Companion_getInstance_2().a7q_1;
    this.x85_1 = new HeadersBuilder();
    this.y85_1 = EmptyContent_getInstance();
    this.z85_1 = SupervisorJob();
    this.a86_1 = AttributesJsFn(true);
  }
  z7p() {
    return this.x85_1;
  }
  o89(value) {
    if (!(value == null)) {
      this.a86_1.j7a(get_BodyTypeAttributeKey(), value);
    } else {
      this.a86_1.l7a(get_BodyTypeAttributeKey());
    }
  }
  h8i() {
    return this.a86_1.h7a(get_BodyTypeAttributeKey());
  }
  u8h(block) {
    return block(this.v85_1, this.v85_1);
  }
  j7e() {
    var tmp = this.v85_1.j7e();
    var tmp_0 = this.w85_1;
    var tmp_1 = this.x85_1.j7e();
    var tmp_2 = this.y85_1;
    var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent ? tmp_2 : null;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'No request transformation found: ' + toString(this.y85_1);
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    return new HttpRequestData(tmp, tmp_0, tmp_1, tmp_3, this.z85_1, this.a86_1);
  }
  n89(builder) {
    this.z85_1 = builder.z85_1;
    return this.n8e(builder);
  }
  n8e(builder) {
    this.w85_1 = builder.w85_1;
    this.y85_1 = builder.y85_1;
    this.o89(builder.h8i());
    takeFrom_0(this.v85_1, builder.v85_1);
    this.v85_1.l7t_1 = this.v85_1.l7t_1;
    appendAll(this.x85_1, builder.x85_1);
    putAll(this.a86_1, builder.a86_1);
    return this;
  }
  z8g(key, capability) {
    var tmp = get_ENGINE_CAPABILITIES_KEY();
    var capabilities = this.a86_1.m7a(tmp, HttpRequestBuilder$setCapability$lambda);
    // Inline function 'kotlin.collections.set' call
    capabilities.b5(key, capability);
  }
}
class HttpRequestData {
  constructor(url, method, headers, body, executionContext, attributes) {
    this.f89_1 = url;
    this.g89_1 = method;
    this.h89_1 = headers;
    this.i89_1 = body;
    this.j89_1 = executionContext;
    this.k89_1 = attributes;
    var tmp = this;
    var tmp0_safe_receiver = this.k89_1.h7a(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x4();
    tmp.l89_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  }
  toString() {
    return 'HttpRequestData(url=' + this.f89_1.toString() + ', method=' + this.g89_1.toString() + ')';
  }
}
class HttpResponseData {
  constructor(statusCode, requestTime, headers, version, body, callContext) {
    this.i87_1 = statusCode;
    this.j87_1 = requestTime;
    this.k87_1 = headers;
    this.l87_1 = version;
    this.m87_1 = body;
    this.n87_1 = callContext;
    this.o87_1 = GMTDate();
  }
  toString() {
    return 'HttpResponseData=(statusCode=' + this.i87_1.toString() + ')';
  }
}
class ResponseAdapter {}
class Phases {
  constructor() {
    Phases_instance = this;
    this.h8a_1 = new PipelinePhase('Before');
    this.i8a_1 = new PipelinePhase('State');
    this.j8a_1 = new PipelinePhase('Transform');
    this.k8a_1 = new PipelinePhase('Render');
    this.l8a_1 = new PipelinePhase('Send');
  }
}
class HttpRequestPipeline extends Pipeline {
  constructor(developmentMode) {
    Phases_getInstance();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    super([Phases_getInstance().h8a_1, Phases_getInstance().i8a_1, Phases_getInstance().j8a_1, Phases_getInstance().k8a_1, Phases_getInstance().l8a_1]);
    this.q8i_1 = developmentMode;
  }
  t7f() {
    return this.q8i_1;
  }
}
class Phases_0 {
  constructor() {
    Phases_instance_0 = this;
    this.y84_1 = new PipelinePhase('Before');
    this.z84_1 = new PipelinePhase('State');
    this.a85_1 = new PipelinePhase('Monitoring');
    this.b85_1 = new PipelinePhase('Engine');
    this.c85_1 = new PipelinePhase('Receive');
  }
}
class HttpSendPipeline extends Pipeline {
  constructor(developmentMode) {
    Phases_getInstance_0();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    super([Phases_getInstance_0().y84_1, Phases_getInstance_0().z84_1, Phases_getInstance_0().a85_1, Phases_getInstance_0().b85_1, Phases_getInstance_0().c85_1]);
    this.y8i_1 = developmentMode;
  }
  t7f() {
    return this.y8i_1;
  }
}
class DefaultHttpResponse extends HttpResponse {
  constructor(call, responseData) {
    super();
    this.z8i_1 = call;
    this.a8j_1 = responseData.n87_1;
    this.b8j_1 = responseData.i87_1;
    this.c8j_1 = responseData.l87_1;
    this.d8j_1 = responseData.j87_1;
    this.e8j_1 = responseData.o87_1;
    var tmp = this;
    var tmp_0 = responseData.m87_1;
    var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel) ? tmp_0 : null;
    tmp.f8j_1 = tmp0_elvis_lhs == null ? Companion_getInstance().v77_1 : tmp0_elvis_lhs;
    this.g8j_1 = responseData.k87_1;
  }
  t86() {
    return this.z8i_1;
  }
  d1m() {
    return this.a8j_1;
  }
  c87() {
    return this.b8j_1;
  }
  d87() {
    return this.c8j_1;
  }
  e87() {
    return this.d8j_1;
  }
  f87() {
    return this.e8j_1;
  }
  b87() {
    return this.f8j_1;
  }
  z7p() {
    return this.g8j_1;
  }
}
class Phases_1 {
  constructor() {
    Phases_instance_1 = this;
    this.o85_1 = new PipelinePhase('Receive');
    this.p85_1 = new PipelinePhase('Parse');
    this.q85_1 = new PipelinePhase('Transform');
    this.r85_1 = new PipelinePhase('State');
    this.s85_1 = new PipelinePhase('After');
  }
}
class HttpResponsePipeline extends Pipeline {
  constructor(developmentMode) {
    Phases_getInstance_1();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    super([Phases_getInstance_1().o85_1, Phases_getInstance_1().p85_1, Phases_getInstance_1().q85_1, Phases_getInstance_1().r85_1, Phases_getInstance_1().s85_1]);
    this.o8j_1 = developmentMode;
  }
  t7f() {
    return this.o8j_1;
  }
}
class Phases_2 {
  constructor() {
    Phases_instance_2 = this;
    this.o8a_1 = new PipelinePhase('Before');
    this.p8a_1 = new PipelinePhase('State');
    this.q8a_1 = new PipelinePhase('After');
  }
}
class HttpReceivePipeline extends Pipeline {
  constructor(developmentMode) {
    Phases_getInstance_2();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    super([Phases_getInstance_2().o8a_1, Phases_getInstance_2().p8a_1, Phases_getInstance_2().q8a_1]);
    this.w8j_1 = developmentMode;
  }
  t7f() {
    return this.w8j_1;
  }
}
class HttpResponseContainer {
  constructor(expectedType, response) {
    this.v87_1 = expectedType;
    this.w87_1 = response;
  }
  jm() {
    return this.v87_1;
  }
  km() {
    return this.w87_1;
  }
  toString() {
    return 'HttpResponseContainer(expectedType=' + this.v87_1.toString() + ', response=' + toString(this.w87_1) + ')';
  }
  hashCode() {
    var result = this.v87_1.hashCode();
    result = imul(result, 31) + hashCode(this.w87_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpResponseContainer))
      return false;
    if (!this.v87_1.equals(other.v87_1))
      return false;
    if (!equals(this.w87_1, other.w87_1))
      return false;
    return true;
  }
}
class HttpStatement {
  constructor(builder, client) {
    this.v8h_1 = builder;
    this.w8h_1 = client;
  }
  *x8h($completion) {
    $l$block: {
      // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
      try {
        var builder = (new HttpRequestBuilder()).n89(this.v8h_1);
        skipSaveBody(builder);
        var call = yield* this.w8h_1.u85(builder, $completion);
        return call.t84();
      } catch ($p) {
        if ($p instanceof CancellationException_0) {
          var cause = $p;
          throw unwrapCancellationException(cause);
        } else {
          throw $p;
        }
      }
    }
  }
  *y8h(_this__u8e3s4, $completion) {
    var tmp = get_job(_this__u8e3s4.d1m());
    var job = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
    // Inline function 'kotlin.apply' call
    job.o1t();
    if (!get_isSaved(_this__u8e3s4)) {
      try {
        cancel_3(_this__u8e3s4.b87());
      } catch ($p) {
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
        } else {
          throw $p;
        }
      }
    }
    yield* job.k1n($completion);
    return Unit_instance;
  }
  toString() {
    return 'HttpStatement[' + this.v8h_1.v85_1.toString() + ']';
  }
}
class HttpResponseReceiveFail {
  constructor(response, cause) {
    this.x8j_1 = response;
    this.y8j_1 = cause;
  }
}
class EmptyContent extends NoContent {
  constructor() {
    EmptyContent_instance = null;
    super();
    EmptyContent_instance = this;
    this.a8k_1 = new Long(0, 0);
  }
  r7v() {
    return this.a8k_1;
  }
  toString() {
    return 'EmptyContent';
  }
  hashCode() {
    return 1450860306;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EmptyContent))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'FetchOptions';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(FetchOptions);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(FetchOptions), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.b8k_1 = new AttributeKey(name, tmp$ret$1);
  }
}
class FetchOptions {
  constructor(requestInit) {
    Companion_getInstance_12();
    this.c8k_1 = requestInit;
  }
}
class Js {
  d8k(block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new JsClientEngineConfig();
    block(this_0);
    return new JsClientEngine(this_0);
  }
  b86(block) {
    return this.d8k(block);
  }
  toString() {
    return 'Js';
  }
  hashCode() {
    return -527824213;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Js))
      return false;
    return true;
  }
}
class JsClientEngineConfig extends HttpClientEngineConfig {
  constructor() {
    super();
    var tmp = this;
    tmp.i8k_1 = JsClientEngineConfig$requestInit$lambda;
    this.j8k_1 = Object.create(null);
  }
}
class JsClientEngine$createWebSocket$headers_capturingHack$1 {}
class JsClientEngine extends HttpClientEngineBase {
  constructor(config) {
    super('ktor-js');
    this.q8k_1 = config;
    this.r8k_1 = setOf_0([HttpTimeoutCapability_instance, WebSocketCapability_instance, SSECapability_instance]);
    // Inline function 'kotlin.check' call
    if (!(this.q8k_1.z89_1 == null)) {
      var message = 'Proxy unsupported in Js engine.';
      throw IllegalStateException.o(toString(message));
    }
  }
  w84() {
    return this.q8k_1;
  }
  m89() {
    return this.r8k_1;
  }
  *v89(data, $completion) {
    var callContext_0 = yield* callContext($completion);
    var clientConfig = data.k89_1.g7a(get_CLIENT_CONFIG());
    if (isUpgradeRequest(data)) {
      return yield* /*#__NOINLINE__*/executeWebSocketRequest(this, data, callContext_0, $completion);
    }
    var requestTime = GMTDate();
    var rawRequest = yield* toRaw(data, clientConfig, callContext_0, $completion);
    var tmp0_safe_receiver = data.k89_1.h7a(Companion_getInstance_12().b8k_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c8k_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = JsClientEngine$execute$lambda;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var fetchOptions = tmp;
    var rawResponse = yield* commonFetch(data.f89_1.toString(), rawRequest, fetchOptions, this.q8k_1, get_job(callContext_0), $completion);
    var status = new HttpStatusCode(rawResponse.status, rawResponse.statusText);
    var headers = mapToKtor(rawResponse.headers, data.g89_1, data.k89_1);
    var version = Companion_getInstance_5().n7q_1;
    var body = readBody(CoroutineScope(callContext_0), rawResponse);
    var tmp2_safe_receiver = data.k89_1.h7a(get_ResponseAdapterAttributeKey());
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i8i(data, status, headers, body, data.i89_1, callContext_0);
    var responseBody = tmp3_elvis_lhs == null ? body : tmp3_elvis_lhs;
    return new HttpResponseData(status, requestTime, headers, version, responseBody, callContext_0);
  }
}
class JsWebSocketSession {
  constructor(coroutineContext, websocket, channelsConfig) {
    this.s8k_1 = coroutineContext;
    this.t8k_1 = websocket;
    this.u8k_1 = CompletableDeferred();
    this.v8k_1 = from(Factory_getInstance(), channelsConfig.x7z_1);
    this.w8k_1 = from(Factory_getInstance(), channelsConfig.y7z_1);
    this.x8k_1 = this.v8k_1;
    this.y8k_1 = this.w8k_1;
    this.z8k_1 = this.u8k_1;
    var onMessage = JsWebSocketSession$lambda(this);
    var onError = JsWebSocketSession$lambda_0(this);
    var onClose = {_v: null};
    onClose._v = JsWebSocketSession$lambda_1(this, onClose);
    var tmp0_safe_receiver = this.s8k_1.ae(Key_instance);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.g1n(JsWebSocketSession$lambda_2(this, onMessage, onError));
    }
    // Inline function 'org.w3c.dom.ARRAYBUFFER' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0 = 'arraybuffer';
    this.t8k_1.binaryType = tmp$ret$0;
    this.t8k_1.addEventListener('message', onMessage);
    this.t8k_1.addEventListener('error', onError);
    var tmp;
    if (onClose._v == null) {
      throwUninitializedPropertyAccessException('onClose');
    } else {
      tmp = onClose._v;
    }
    this.t8k_1.addEventListener('close', tmp);
    launch(this, VOID, VOID, JsWebSocketSession$slambda(this));
    // Inline function 'kotlin.require' call
    if (!!channelsConfig.x7z_1.l82()) {
      var message = 'Suspendable channels are not supported in JS.';
      throw IllegalArgumentException.h2(toString(message));
    }
  }
  d1m() {
    return this.s8k_1;
  }
  t7z() {
    return this.x8k_1;
  }
  u7z() {
    return this.y8k_1;
  }
  r7z(_) {
    throw WebSocketException.e8h('Max frame size switch is not supported in Js engine.');
  }
  s7z() {
    return new Long(-1, 2147483647);
  }
  q7z(negotiatedExtensions) {
    // Inline function 'kotlin.require' call
    if (!negotiatedExtensions.n1()) {
      var message = 'Extensions are not supported.';
      throw IllegalArgumentException.h2(toString(message));
    }
  }
  *f77($completion) {
    return Unit_instance;
  }
}
class Node {
  constructor(item, next) {
    this.a8l_1 = item;
    this.b8l_1 = next;
  }
}
class engines$iterator$1 {
  constructor() {
    this.c8l_1 = engines_getInstance().k8k_1.kotlinx$atomicfu$value;
  }
  r1() {
    var result = ensureNotNull(this.c8l_1);
    this.c8l_1 = result.b8l_1;
    return result.a8l_1;
  }
  q1() {
    return !(null == this.c8l_1);
  }
}
class engines {
  constructor() {
    engines_instance = this;
    this.k8k_1 = atomic$ref$1(null);
  }
  l8k(item) {
    $l$loop: while (true) {
      var current = this.k8k_1.kotlinx$atomicfu$value;
      var new_0 = new Node(item, current);
      if (this.k8k_1.atomicfu$compareAndSet(current, new_0))
        break $l$loop;
    }
  }
  p1() {
    return new engines$iterator$1();
  }
}
class ConnectTimeoutException extends IOException {}
class InterruptedIOException extends IOException {}
class SocketTimeoutException extends InterruptedIOException {}
//endregion
function HttpClient$lambda(this$0) {
  return (it) => {
    var tmp;
    if (!(it == null)) {
      cancel(this$0.a84_1);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HttpClient$slambda(this$0) {
  return constructCallableReference(function *($this$intercept, call, $completion) {
    // Inline function 'kotlin.check' call
    if (!(call instanceof HttpClientCall)) {
      var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
      throw IllegalStateException.o(toString(message));
    }
    var response = yield* this$0.j84_1.u7f(Unit_instance, call.t84(), $completion);
    call.u84(response);
    yield* $this$intercept.x7e(call, $completion);
    return Unit_instance;
  }, 2);
}
function HttpClient$lambda_0($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
function HttpClient$slambda_0(this$0) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    try {
      yield* $this$intercept.y7e($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        this$0.m84_1.b7h(get_HttpResponseReceiveFailed(), new HttpResponseReceiveFail($this$intercept.v7f_1.t84(), cause));
        throw cause;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 2);
}
function HttpClient_0(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_1;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new HttpClientConfig();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.b86(config.g85_1);
  var client = HttpClient.t85(engine, config, true);
  var tmp_0 = ensureNotNull(client.f84_1.ae(Key_instance));
  tmp_0.g1n(HttpClient$lambda_2(engine));
  return client;
}
function HttpClient$lambda_1(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClient$lambda_2($engine) {
  return (it) => {
    $engine.f7();
    return Unit_instance;
  };
}
function installPlugin($this, plugin) {
  if ($this.d85_1.u4(plugin.j3()))
    return Unit_instance;
  var tmp0 = $this.d85_1;
  var tmp2 = plugin.j3();
  // Inline function 'kotlin.collections.set' call
  var value = HttpClientConfig$installPlugin$lambda(plugin);
  tmp0.b5(tmp2, value);
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda_0($previousConfigBlock, $configure) {
  return (_this__u8e3s4) => {
    var tmp0_safe_receiver = $previousConfigBlock;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    $configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
    return Unit_instance;
  };
}
function HttpClientConfig$installPlugin$lambda$lambda() {
  return AttributesJsFn(true);
}
function HttpClientConfig$installPlugin$lambda($plugin) {
  return (scope) => {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.k84_1.m7a(tmp, HttpClientConfig$installPlugin$lambda$lambda);
    var config = ensureNotNull(scope.n84_1.e85_1.w4($plugin.j3()));
    var pluginData = $plugin.c86(config);
    $plugin.d86(pluginData, scope);
    attributes.j7a($plugin.j3(), pluginData);
    return Unit_instance;
  };
}
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.t84().z7p() : headers;
  return DelegatedCall.k86(_this__u8e3s4.o84_1, _this__u8e3s4, content, headers);
}
var Companion_instance_0;
function Companion_getInstance_8() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall)
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.t84().b87(), $completion));
  return SavedHttpCall.k88(_this__u8e3s4.o84_1, _this__u8e3s4.m86(), _this__u8e3s4.t84(), responseBody);
}
function getContent($this, delegate) {
  var tmp;
  if (delegate instanceof ContentWrapper) {
    tmp = getContent($this, delegate.a7w());
  } else {
    if (delegate instanceof ByteArrayContent) {
      tmp = ByteReadChannel_0(delegate.x7v());
    } else {
      if (delegate instanceof ProtocolUpgrade) {
        throw UnsupportedContentTypeException.z88(delegate);
      } else {
        if (delegate instanceof NoContent) {
          tmp = Companion_getInstance().v77_1;
        } else {
          if (delegate instanceof ReadChannelContent) {
            tmp = delegate.t7v();
          } else {
            if (delegate instanceof WriteChannelContent) {
              var tmp_0 = GlobalScope_instance;
              tmp = writer(tmp_0, $this.d89_1, true, ObservableContent$getContent$slambda(delegate)).b78_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function ObservableContent$getContent$slambda($delegate) {
  return constructCallableReference(function *($this$writer, $completion) {
    yield* $delegate.v7v($this$writer.d78_1, $completion);
    return Unit_instance;
  }, 1);
}
function get_CALL_COROUTINE() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CALL_COROUTINE;
}
var CALL_COROUTINE;
function get_CLIENT_CONFIG() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CLIENT_CONFIG;
}
var CLIENT_CONFIG;
function _get_closed__iwkfs1($this) {
  var tmp0_safe_receiver = $this.d1m().ae(Key_instance);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e1m();
  return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
}
function *executeWithinCallContext($this, requestData, $completion) {
  var callContext = yield* createCallContext($this, requestData.j89_1, $completion);
  var context = callContext.ep(new KtorCallContextElement(callContext));
  return yield* async($this, context, VOID, HttpClientEngine$executeWithinCallContext$slambda($this, requestData)).m1q($completion);
}
function checkExtensions($this, requestData) {
  var _iterator__ex2g4s = requestData.l89_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var requestedExtension = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.require' call
    if (!$this.m89().w2(requestedExtension)) {
      var message = "Engine doesn't support " + toString(requestedExtension);
      throw IllegalArgumentException.h2(toString(message));
    }
  }
}
function HttpClientEngine$install$slambda$lambda($client, $response) {
  return (it) => {
    var tmp;
    if (!(it == null)) {
      $client.m84_1.b7h(get_HttpResponseCancelled(), $response);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HttpClientEngine$install$slambda($client, this$0) {
  return constructCallableReference(function *($this$intercept, content, $completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpRequestBuilder();
    this_0.n89($this$intercept.v7f_1);
    // Inline function 'io.ktor.client.request.setBody' call
    if (content == null) {
      this_0.y85_1 = NullBody_instance;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = PrimitiveClasses_getInstance().hg();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(PrimitiveClasses_getInstance().hg(), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$4 = tmp_0;
      var tmp$ret$3 = new TypeInfo(tmp, tmp$ret$4);
      this_0.o89(tmp$ret$3);
    } else {
      if (content instanceof OutgoingContent) {
        this_0.y85_1 = content;
        this_0.o89(null);
      } else {
        this_0.y85_1 = content;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_2 = PrimitiveClasses_getInstance().hg();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_3;
        try {
          tmp_3 = createKType(PrimitiveClasses_getInstance().hg(), arrayOf([]), false);
        } catch ($p_0) {
          var tmp_4;
          if ($p_0 instanceof Error) {
            var _unused_var__etf5q3_0 = $p_0;
            tmp_4 = null;
          } else {
            throw $p_0;
          }
          tmp_3 = tmp_4;
        }
        var tmp$ret$6 = tmp_3;
        var tmp$ret$5 = new TypeInfo(tmp_2, tmp$ret$6);
        this_0.o89(tmp$ret$5);
      }
    }
    var builder = this_0;
    $client.m84_1.b7h(get_HttpRequestIsReadyForSending(), builder);
    // Inline function 'kotlin.apply' call
    var this_1 = builder.j7e();
    this_1.k89_1.j7a(get_CLIENT_CONFIG(), $client.n84_1);
    var requestData = this_1;
    validateHeaders(requestData);
    checkExtensions(this$0, requestData);
    var responseData = yield* /*#__NOINLINE__*/executeWithinCallContext(this$0, requestData, $completion);
    var call = HttpClientCall.h87($client, requestData, responseData);
    var response = call.t84();
    $client.m84_1.b7h(get_HttpResponseReceived(), response);
    var tmp_5 = get_job(response.d1m());
    tmp_5.g1n(HttpClientEngine$install$slambda$lambda($client, response));
    yield* $this$intercept.x7e(call, $completion);
    return Unit_instance;
  }, 2);
}
function HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData) {
  return constructCallableReference(function *($this$async, $completion) {
    var tmp;
    if (_get_closed__iwkfs1(this$0)) {
      throw ClientEngineClosedException.u89();
    }
    return yield* this$0.v89($requestData, $completion);
  }, 1);
}
function validateHeaders(request) {
  _init_properties_HttpClientEngine_kt__h91z5h();
  var requestHeaders = request.h89_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = requestHeaders.z7b();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (HttpHeaders_getInstance().c7p_1.w2(element)) {
      destination.d2(element);
    }
  }
  var unsafeRequestHeaders = destination;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!unsafeRequestHeaders.n1()) {
    throw UnsafeHeaderException.y7p(toString(unsafeRequestHeaders));
  }
}
function *createCallContext(_this__u8e3s4, parentJob, $completion) {
  var callJob = Job(parentJob);
  var callContext = _this__u8e3s4.d1m().ep(callJob).ep(get_CALL_COROUTINE());
  $l$block: {
    // Inline function 'io.ktor.client.engine.attachToUserJob' call
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp0_elvis_lhs = $completion.od().ae(Key_instance);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$block;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var userJob = tmp;
    var cleanupHandler = userJob.i1n(true, VOID, createCallContext$lambda(callJob));
    callJob.g1n(createCallContext$lambda_0(cleanupHandler));
  }
  return callContext;
}
function createCallContext$lambda($callJob) {
  return (cause) => {
    if (cause == null)
      return Unit_instance;
    $callJob.n1n(CancellationException_0.n(cause.message));
    return Unit_instance;
  };
}
function createCallContext$lambda_0($cleanupHandler) {
  return (it) => {
    $cleanupHandler.u1o();
    return Unit_instance;
  };
}
var properties_initialized_HttpClientEngine_kt_5uiebb;
function _init_properties_HttpClientEngine_kt__h91z5h() {
  if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
    properties_initialized_HttpClientEngine_kt_5uiebb = true;
    CALL_COROUTINE = CoroutineName.b1u('call-context');
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'client-config';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(HttpClientConfig);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(HttpClientConfig), arrayOf([getStarKTypeProjection()]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    CLIENT_CONFIG = new AttributeKey(name, tmp$ret$1);
  }
}
function HttpClientEngineBase$dispatcher$delegate$lambda(this$0) {
  return () => {
    var tmp0_elvis_lhs = this$0.w84().x89_1;
    return tmp0_elvis_lhs == null ? ioDispatcher() : tmp0_elvis_lhs;
  };
}
function HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v() {
  return constructCallableReference((p0) => p0.e8a(), 1, 0, 29);
}
function HttpClientEngineBase$coroutineContext$delegate$lambda(this$0) {
  return () => SilentSupervisor().ep(this$0.e8a()).ep(CoroutineName.b1u(this$0.a8a_1 + '-context'));
}
function HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr() {
  return constructCallableReference((p0) => p0.d1m(), 1, 0, 30);
}
function get_ENGINE_CAPABILITIES_KEY() {
  _init_properties_HttpClientEngineCapability_kt__ifvyst();
  return ENGINE_CAPABILITIES_KEY;
}
var ENGINE_CAPABILITIES_KEY;
var DEFAULT_CAPABILITIES;
var properties_initialized_HttpClientEngineCapability_kt_qarzcf;
function _init_properties_HttpClientEngineCapability_kt__ifvyst() {
  if (!properties_initialized_HttpClientEngineCapability_kt_qarzcf) {
    properties_initialized_HttpClientEngineCapability_kt_qarzcf = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'EngineCapabilities';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtMutableMap);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtMutableMap), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpClientEngineCapability), arrayOf([getStarKTypeProjection()]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().hg(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    ENGINE_CAPABILITIES_KEY = new AttributeKey(name, tmp$ret$1);
    DEFAULT_CAPABILITIES = setOf(HttpTimeoutCapability_instance);
  }
}
function get_KTOR_DEFAULT_USER_AGENT() {
  _init_properties_Utils_kt__jo07cx();
  return KTOR_DEFAULT_USER_AGENT;
}
var KTOR_DEFAULT_USER_AGENT;
function get_DATE_HEADERS() {
  _init_properties_Utils_kt__jo07cx();
  return DATE_HEADERS;
}
var DATE_HEADERS;
var Companion_instance_1;
function Companion_getInstance_9() {
  return Companion_instance_1;
}
function *callContext($completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.od();
  return ensureNotNull(tmp$ret$0.ae(Companion_instance_1)).f8a_1;
}
function mergeHeaders(requestHeaders, content, block) {
  _init_properties_Utils_kt__jo07cx();
  var tmp = buildHeaders(mergeHeaders$lambda(requestHeaders, content));
  tmp.a7c(mergeHeaders$lambda_0(block));
  var missingAgent = requestHeaders.wi('User-Agent') == null && content.z7p().wi('User-Agent') == null;
  if (missingAgent && needUserAgent()) {
    block('User-Agent', get_KTOR_DEFAULT_USER_AGENT());
  }
  var tmp0_safe_receiver = content.q7v();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? content.z7p().wi('Content-Type') : tmp1_elvis_lhs;
  var type = tmp2_elvis_lhs == null ? requestHeaders.wi('Content-Type') : tmp2_elvis_lhs;
  var tmp3_safe_receiver = content.r7v();
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
  var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? content.z7p().wi('Content-Length') : tmp4_elvis_lhs;
  var length = tmp5_elvis_lhs == null ? requestHeaders.wi('Content-Length') : tmp5_elvis_lhs;
  if (type == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    block('Content-Type', type);
  }
  if (length == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    block('Content-Length', length);
  }
}
function needUserAgent() {
  _init_properties_Utils_kt__jo07cx();
  return !PlatformUtils_getInstance().n7b_1;
}
function mergeHeaders$lambda($requestHeaders, $content) {
  return ($this$buildHeaders) => {
    $this$buildHeaders.h7c($requestHeaders);
    $this$buildHeaders.h7c($content.z7p());
    return Unit_instance;
  };
}
function mergeHeaders$lambda_0($block) {
  return (key, values) => {
    var tmp;
    if ('Content-Length' === key) {
      return Unit_instance;
    }
    var tmp_0;
    if ('Content-Type' === key) {
      return Unit_instance;
    }
    var tmp_1;
    if (get_DATE_HEADERS().w2(key)) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = values.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        $block(key, element);
      }
      tmp_1 = Unit_instance;
    } else {
      var separator = 'Cookie' === key ? '; ' : ',';
      tmp_1 = $block(key, joinToString(values, separator));
    }
    return Unit_instance;
  };
}
var properties_initialized_Utils_kt_xvi83j;
function _init_properties_Utils_kt__jo07cx() {
  if (!properties_initialized_Utils_kt_xvi83j) {
    properties_initialized_Utils_kt_xvi83j = true;
    KTOR_DEFAULT_USER_AGENT = 'ktor-client';
    DATE_HEADERS = setOf_0(['Date', 'Expires', 'Last-Modified', 'If-Modified-Since', 'If-Unmodified-Since']);
  }
}
function get_UploadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return UploadProgressListenerAttributeKey;
}
var UploadProgressListenerAttributeKey;
function get_DownloadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return DownloadProgressListenerAttributeKey;
}
var DownloadProgressListenerAttributeKey;
function get_BodyProgress() {
  _init_properties_BodyProgress_kt__s0v569();
  return BodyProgress;
}
var BodyProgress;
function AfterRenderHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, content, $completion) {
    var tmp;
    if (!(content instanceof OutgoingContent)) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = yield* $handler($this$intercept.v7f_1, content, $completion);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var newContent = tmp_0;
    yield* $this$intercept.x7e(newContent, $completion);
    return Unit_instance;
  }, 2);
}
var AfterRenderHook_instance;
function AfterRenderHook_getInstance() {
  return AfterRenderHook_instance;
}
function AfterReceiveHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, response, $completion) {
    var newResponse = yield* $handler(response, $completion);
    var tmp;
    if (!(newResponse == null)) {
      yield* $this$intercept.x7e(newResponse, $completion);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
var AfterReceiveHook_instance;
function AfterReceiveHook_getInstance() {
  return AfterReceiveHook_instance;
}
function withObservableDownload(_this__u8e3s4, listener) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = _this__u8e3s4.t86();
  return replaceResponse(tmp, VOID, withObservableDownload$lambda(listener)).t84();
}
function BodyProgress$lambda($this$createClientPlugin) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = AfterRenderHook_instance;
  $this$createClientPlugin.w8a(tmp, BodyProgress$lambda$slambda());
  var tmp_0 = AfterReceiveHook_instance;
  $this$createClientPlugin.w8a(tmp_0, BodyProgress$lambda$slambda_0());
  return Unit_instance;
}
function BodyProgress$lambda$slambda() {
  return constructCallableReference(function *(request, content, $completion) {
    var tmp0_elvis_lhs = request.a86_1.h7a(get_UploadProgressListenerAttributeKey());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var listener = tmp;
    return new ObservableContent(content, request.z85_1, listener);
  }, 2);
}
function BodyProgress$lambda$slambda_0() {
  return constructCallableReference(function *(response, $completion) {
    var tmp0_elvis_lhs = response.t86().m86().n86().h7a(get_DownloadProgressListenerAttributeKey());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var listener = tmp;
    return withObservableDownload(response, listener);
  }, 1);
}
function withObservableDownload$lambda($listener) {
  return ($this$replaceResponse) => observable($this$replaceResponse.b87(), $this$replaceResponse.d1m(), contentLength($this$replaceResponse), $listener);
}
var properties_initialized_BodyProgress_kt_pmfrhr;
function _init_properties_BodyProgress_kt__s0v569() {
  if (!properties_initialized_BodyProgress_kt_pmfrhr) {
    properties_initialized_BodyProgress_kt_pmfrhr = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'UploadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ProgressListener);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ProgressListener), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    UploadProgressListenerAttributeKey = new AttributeKey(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'DownloadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(ProgressListener);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(ProgressListener), arrayOf([]), false);
    } catch ($p_0) {
      var tmp_4;
      if ($p_0 instanceof Error) {
        var _unused_var__etf5q3_0 = $p_0;
        tmp_4 = null;
      } else {
        throw $p_0;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$2_0 = tmp_3;
    var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$2_0);
    DownloadProgressListenerAttributeKey = new AttributeKey(name_0, tmp$ret$1_0);
    BodyProgress = createClientPlugin_0('BodyProgress', BodyProgress$lambda);
  }
}
function get_ValidateMark() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return ValidateMark;
}
var ValidateMark;
function get_LOGGER() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return LOGGER;
}
var LOGGER;
function addDefaultResponseValidation(_this__u8e3s4) {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  HttpResponseValidator(_this__u8e3s4, addDefaultResponseValidation$lambda(_this__u8e3s4));
}
function addDefaultResponseValidation$lambda$slambda() {
  return constructCallableReference(function *(response, $completion) {
    var expectSuccess = response.t86().n86().g7a(get_ExpectSuccessAttributeKey());
    var tmp;
    if (!expectSuccess) {
      get_LOGGER().z7g('Skipping default response validation for ' + response.t86().m86().v86().toString());
      return Unit_instance;
    }
    var statusCode = response.c87().x7s_1;
    var originCall = response.t86();
    var tmp_0;
    if (statusCode < 300 || originCall.n86().i7a(get_ValidateMark())) {
      return Unit_instance;
    }
    // Inline function 'kotlin.apply' call
    var this_0 = yield* save(originCall, $completion);
    this_0.n86().j7a(get_ValidateMark(), Unit_instance);
    var exceptionCall = this_0;
    var exceptionResponse = exceptionCall.t84();
    var tmp_1;
    try {
      tmp_1 = yield* bodyAsText(exceptionResponse, VOID, $completion);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof MalformedInputException) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = '<body failed decoding>';
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var exceptionResponseText = tmp_1;
    var exception = (300 <= statusCode ? statusCode <= 399 : false) ? RedirectResponseException.k8b(exceptionResponse, exceptionResponseText) : (400 <= statusCode ? statusCode <= 499 : false) ? ClientRequestException.s8b(exceptionResponse, exceptionResponseText) : (500 <= statusCode ? statusCode <= 599 : false) ? ServerResponseException.a8c(exceptionResponse, exceptionResponseText) : ResponseException.c8b(exceptionResponse, exceptionResponseText);
    get_LOGGER().z7g('Default response validation for ' + response.t86().m86().v86().toString() + ' failed with ' + exception.toString());
    throw exception;
  }, 1);
}
function addDefaultResponseValidation$lambda($this_addDefaultResponseValidation) {
  return ($this$HttpResponseValidator) => {
    $this$HttpResponseValidator.d8c_1 = $this_addDefaultResponseValidation.j85_1;
    $this$HttpResponseValidator.e8c(addDefaultResponseValidation$lambda$slambda());
    return Unit_instance;
  };
}
var properties_initialized_DefaultResponseValidation_kt_akvzqt;
function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
  if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
    properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ValidateMark';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    ValidateMark = new AttributeKey(name, tmp$ret$1);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
  }
}
function get_LOGGER_0() {
  _init_properties_DefaultTransform_kt__20knxx();
  return LOGGER_0;
}
var LOGGER_0;
function defaultTransformers(_this__u8e3s4) {
  _init_properties_DefaultTransform_kt__20knxx();
  var tmp = Phases_getInstance().k8a_1;
  _this__u8e3s4.g84_1.z7f(tmp, defaultTransformers$slambda());
  var tmp_0 = Phases_getInstance_1().p85_1;
  _this__u8e3s4.h84_1.z7f(tmp_0, defaultTransformers$slambda_0(_this__u8e3s4));
  platformResponseDefaultTransformers(_this__u8e3s4);
}
function defaultTransformers$slambda() {
  return constructCallableReference(function *($this$intercept, body, $completion) {
    var tmp;
    if ($this$intercept.v7f_1.x85_1.wi('Accept') == null) {
      $this$intercept.v7f_1.x85_1.g7c('Accept', '*/*');
      tmp = Unit_instance;
    }
    var contentType_0 = contentType($this$intercept.v7f_1);
    var tmp_0;
    if (typeof body === 'string') {
      tmp_0 = new TextContent(body, contentType_0 == null ? Text_getInstance().i7j_1 : contentType_0);
    } else {
      if (isByteArray(body)) {
        tmp_0 = new defaultTransformers$1$content$1(contentType_0, body);
      } else {
        if (isInterface(body, ByteReadChannel)) {
          tmp_0 = new defaultTransformers$1$content$2($this$intercept, contentType_0, body);
        } else {
          if (body instanceof OutgoingContent) {
            tmp_0 = body;
          } else {
            tmp_0 = platformRequestDefaultTransform(contentType_0, $this$intercept.v7f_1, body);
          }
        }
      }
    }
    var content = tmp_0;
    var tmp_1;
    if (!((content == null ? null : content.q7v()) == null)) {
      $this$intercept.v7f_1.x85_1.i7c('Content-Type');
      get_LOGGER_0().z7g('Transformed with default transformers request body for ' + $this$intercept.v7f_1.v85_1.toString() + ' from ' + toString(getKClassFromExpression(body)));
      yield* $this$intercept.x7e(content, $completion);
      tmp_1 = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
function defaultTransformers$slambda$slambda($body, $response) {
  return constructCallableReference(function *($this$writer, $completion) {
    try {
      yield* copyTo($body, $this$writer.d78_1, new Long(-1, 2147483647), $completion);
    } catch ($p) {
      if ($p instanceof CancellationException_0) {
        var cause = $p;
        cancel($response, cause);
        throw cause;
      } else {
        if ($p instanceof Error) {
          var cause_0 = $p;
          cancel_0($response, 'Receive failed', cause_0);
          throw cause_0;
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }, 1);
}
function defaultTransformers$slambda$lambda($responseJobHolder) {
  return (it) => {
    $responseJobHolder.o1t();
    return Unit_instance;
  };
}
function defaultTransformers$slambda_0($this_defaultTransformers) {
  return constructCallableReference(function *($this$intercept, _destruct__k2r9zo, $completion) {
    var info = _destruct__k2r9zo.jm();
    var body = _destruct__k2r9zo.km();
    if (!isInterface(body, ByteReadChannel))
      return Unit_instance;
    var response = $this$intercept.v7f_1.t84();
    var tmp0_subject = info.n7g_1;
    var tmp;
    if (tmp0_subject.equals(getKClass(Unit))) {
      cancel_3(body);
      tmp = yield* $this$intercept.x7e(new HttpResponseContainer(info, Unit_instance), $completion);
    } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().ng())) {
      tmp = yield* $this$intercept.x7e(new HttpResponseContainer(info, toInt(readText(yield* readRemaining(body, $completion)))), $completion);
    } else if (tmp0_subject.equals(getKClass(Source)) || tmp0_subject.equals(getKClass(Source))) {
      tmp = yield* $this$intercept.x7e(new HttpResponseContainer(info, yield* readRemaining(body, $completion)), $completion);
    } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().wg())) {
      var bytes = yield* toByteArray(body, $completion);
      checkContentLength(contentLength($this$intercept.v7f_1.t84()), fromInt(bytes.length), $this$intercept.v7f_1.m86().u86());
      tmp = yield* $this$intercept.x7e(new HttpResponseContainer(info, bytes), $completion);
    } else if (tmp0_subject.equals(getKClass(ByteReadChannel))) {
      var responseJobHolder = Job(response.d1m().ae(Key_instance));
      // Inline function 'kotlin.also' call
      var this_0 = writer($this$intercept, $this_defaultTransformers.f84_1, VOID, defaultTransformers$slambda$slambda(body, response));
      invokeOnCompletion(this_0, defaultTransformers$slambda$lambda(responseJobHolder));
      var channel = this_0.b78_1;
      tmp = yield* $this$intercept.x7e(new HttpResponseContainer(info, channel), $completion);
    } else if (tmp0_subject.equals(getKClass(HttpStatusCode))) {
      cancel_3(body);
      tmp = yield* $this$intercept.x7e(new HttpResponseContainer(info, response.c87()), $completion);
    } else if (tmp0_subject.equals(getKClass(MultiPartData))) {
      var tmp0 = $this$intercept.v7f_1.t84().z7p().wi('Content-Type');
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'No content type provided for multipart';
          throw IllegalStateException.o(toString(message));
        } else {
          tmp$ret$2 = tmp0;
          break $l$block;
        }
      }
      var rawContentType = tmp$ret$2;
      var contentType = Companion_getInstance_0().gx(rawContentType);
      // Inline function 'kotlin.check' call
      if (!contentType.u7j(MultiPart_getInstance().b7j_1)) {
        var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
        throw IllegalStateException.o(toString(message_0));
      }
      var tmp1_safe_receiver = $this$intercept.v7f_1.t84().z7p().wi('Content-Length');
      var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
      var body_0 = new CIOMultipartDataBase($this$intercept.d1m(), body, rawContentType, contentLength_0);
      var parsedResponse = new HttpResponseContainer(info, body_0);
      tmp = yield* $this$intercept.x7e(parsedResponse, $completion);
    } else {
      tmp = null;
    }
    var result = tmp;
    var tmp_0;
    if (!(result == null)) {
      get_LOGGER_0().z7g('Transformed with default transformers response body ' + ('for ' + $this$intercept.v7f_1.m86().v86().toString() + ' to ' + toString(info.n7g_1)));
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
var properties_initialized_DefaultTransform_kt_ossax9;
function _init_properties_DefaultTransform_kt__20knxx() {
  if (!properties_initialized_DefaultTransform_kt_ossax9) {
    properties_initialized_DefaultTransform_kt_ossax9 = true;
    LOGGER_0 = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
  }
}
function get_LOGGER_1() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return LOGGER_1;
}
var LOGGER_1;
function get_HttpCallValidator() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return HttpCallValidator;
}
var HttpCallValidator;
function get_ExpectSuccessAttributeKey() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return ExpectSuccessAttributeKey;
}
var ExpectSuccessAttributeKey;
function HttpResponseValidator(_this__u8e3s4, block) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  _this__u8e3s4.e86(get_HttpCallValidator(), block);
}
function RequestError$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    try {
      yield* $this$intercept.y7e($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $handler(HttpRequest_0($this$intercept.v7f_1), cause, $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 2);
}
var RequestError_instance;
function RequestError_getInstance() {
  return RequestError_instance;
}
function ReceiveError$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    try {
      yield* $this$intercept.y7e($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $handler($this$intercept.v7f_1.m86(), cause, $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 2);
}
var ReceiveError_instance;
function ReceiveError_getInstance() {
  return ReceiveError_instance;
}
function HttpRequest_0(builder) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return new HttpRequest$1(builder);
}
function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
  return constructCallableReference(() => new HttpCallValidatorConfig(), 0, 0, 31, '<init>');
}
function HttpCallValidator$lambda($this$createClientPlugin) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  var responseValidators = reversed($this$createClientPlugin.t8a_1.b8c_1);
  var callExceptionHandlers = reversed($this$createClientPlugin.t8a_1.c8c_1);
  var expectSuccess = $this$createClientPlugin.t8a_1.d8c_1;
  var tmp = SetupRequest_instance;
  $this$createClientPlugin.w8a(tmp, HttpCallValidator$lambda$slambda(expectSuccess));
  var tmp_0 = Send_instance;
  $this$createClientPlugin.w8a(tmp_0, HttpCallValidator$lambda$slambda_0(responseValidators));
  var tmp_1 = RequestError_instance;
  $this$createClientPlugin.w8a(tmp_1, HttpCallValidator$lambda$slambda_1(callExceptionHandlers));
  var tmp_2 = ReceiveError_instance;
  $this$createClientPlugin.w8a(tmp_2, HttpCallValidator$lambda$slambda_2(callExceptionHandlers));
  return Unit_instance;
}
function *invoke$validateResponse(responseValidators, response, $completion) {
  get_LOGGER_1().z7g('Validating response for request ' + response.t86().m86().v86().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = responseValidators.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    yield* element(response, $completion);
  }
  return Unit_instance;
}
function *invoke$processException(callExceptionHandlers, cause, request, $completion) {
  get_LOGGER_1().z7g('Processing exception ' + cause.toString() + ' for request ' + request.v86().toString());
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = callExceptionHandlers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ExceptionHandlerWrapper)
      yield* element.p8c_1(cause, $completion);
    else {
      if (element instanceof RequestExceptionHandlerWrapper)
        yield* element.o8c_1(cause, request, $completion);
      else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function HttpCallValidator$lambda$slambda$lambda($expectSuccess) {
  return () => $expectSuccess;
}
function HttpCallValidator$lambda$slambda($expectSuccess) {
  return constructCallableReference(function *(request, $completion) {
    var tmp = get_ExpectSuccessAttributeKey();
    request.a86_1.m7a(tmp, HttpCallValidator$lambda$slambda$lambda($expectSuccess));
    return Unit_instance;
  }, 1);
}
function HttpCallValidator$lambda$slambda_0($responseValidators) {
  return constructCallableReference(function *($this$on, request, $completion) {
    var call = yield* $this$on.s8c(request, $completion);
    yield* /*#__NOINLINE__*/invoke$validateResponse($responseValidators, call.t84(), $completion);
    return call;
  }, 2);
}
function HttpCallValidator$lambda$slambda_1($callExceptionHandlers) {
  return constructCallableReference(function *(request, cause, $completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }, 2);
}
function HttpCallValidator$lambda$slambda_2($callExceptionHandlers) {
  return constructCallableReference(function *(request, cause, $completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }, 2);
}
var properties_initialized_HttpCallValidator_kt_xrx49w;
function _init_properties_HttpCallValidator_kt__r6yh2y() {
  if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
    properties_initialized_HttpCallValidator_kt_xrx49w = true;
    LOGGER_1 = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
    var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
    HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExpectSuccessAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().kg();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    ExpectSuccessAttributeKey = new AttributeKey(name, tmp$ret$1);
  }
}
function get_PLUGIN_INSTALLED_LIST() {
  _init_properties_HttpClientPlugin_kt__cypu1m();
  return PLUGIN_INSTALLED_LIST;
}
var PLUGIN_INSTALLED_LIST;
function plugin(_this__u8e3s4, plugin) {
  _init_properties_HttpClientPlugin_kt__cypu1m();
  var tmp0_elvis_lhs = pluginOrNull(_this__u8e3s4, plugin);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.o('Plugin ' + toString(plugin) + ' is not installed. Consider using `install(' + plugin.j3().toString() + ')` in client config first.');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function pluginOrNull(_this__u8e3s4, plugin) {
  _init_properties_HttpClientPlugin_kt__cypu1m();
  var tmp0_safe_receiver = _this__u8e3s4.k84_1.h7a(get_PLUGIN_INSTALLED_LIST());
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h7a(plugin.j3());
}
var properties_initialized_HttpClientPlugin_kt_p98320;
function _init_properties_HttpClientPlugin_kt__cypu1m() {
  if (!properties_initialized_HttpClientPlugin_kt_p98320) {
    properties_initialized_HttpClientPlugin_kt_p98320 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ApplicationPluginRegistry';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Attributes);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Attributes), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    PLUGIN_INSTALLED_LIST = new AttributeKey(name, tmp$ret$1);
  }
}
function get_LOGGER_2() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return LOGGER_2;
}
var LOGGER_2;
function get_HttpPlainText() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return HttpPlainText;
}
var HttpPlainText;
function RenderRequestHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, content, $completion) {
    var result = yield* $handler($this$intercept.v7f_1, content, $completion);
    var tmp;
    if (!(result == null)) {
      yield* $this$intercept.x7e(result, $completion);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
var RenderRequestHook_instance;
function RenderRequestHook_getInstance() {
  return RenderRequestHook_instance;
}
function HttpPlainTextConfig$_init_$ref_isjudo() {
  return constructCallableReference(() => new HttpPlainTextConfig(), 0, 0, 32, '<init>');
}
function HttpPlainText$lambda($this$createClientPlugin) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList($this$createClientPlugin.t8a_1.z8c_1);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HttpPlainText$lambda$lambda;
  var tmp$ret$1 = new sam$kotlin_Comparator$0(tmp);
  var withQuality = sortedWith(this_0, tmp$ret$1);
  var responseCharsetFallback = $this$createClientPlugin.t8a_1.b8d_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$createClientPlugin.t8a_1.y8c_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!$this$createClientPlugin.t8a_1.z8c_1.u4(element)) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = HttpPlainText$lambda$lambda_0;
  var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
  var withoutQuality = sortedWith(destination, tmp$ret$6);
  var tmp_1;
  var tmp0_0 = $this$createClientPlugin.t8a_1.y8c_1;
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_2;
    if (isInterface(tmp0_0, Collection)) {
      tmp_2 = tmp0_0.n1();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$7 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (!element_0.equals(Charsets_getInstance().c79_1)) {
        tmp$ret$7 = true;
        break $l$block_0;
      }
    }
    tmp$ret$7 = false;
  }
  if (tmp$ret$7) {
    tmp_1 = true;
  } else {
    var tmp0_1 = $this$createClientPlugin.t8a_1.z8c_1.x4();
    var tmp$ret$9;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_3;
      if (isInterface(tmp0_1, Collection)) {
        tmp_3 = tmp0_1.n1();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$9 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_1 = tmp0_1.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        if (!element_1.equals(Charsets_getInstance().c79_1)) {
          tmp$ret$9 = true;
          break $l$block_2;
        }
      }
      tmp$ret$9 = false;
    }
    tmp_1 = tmp$ret$9;
  }
  var hasRegisteredCharsets = tmp_1;
  var tmp_4;
  if (hasRegisteredCharsets) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder.l1();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = withoutQuality.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var element_2 = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      this_1.m1(get_name(element_2));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_3 = withQuality.p1();
    while (_iterator__ex2g4s_3.q1()) {
      var element_3 = _iterator__ex2g4s_3.r1();
      var charset = element_3.jm();
      var quality = element_3.km();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      // Inline function 'kotlin.check' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        throw IllegalStateException.o('Check failed.');
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.m1(get_name(charset) + ';q=' + truncatedQuality);
    }
    tmp_4 = this_1.toString();
  } else {
    tmp_4 = null;
  }
  var acceptCharsetHeader = tmp_4;
  var tmp0_elvis_lhs = $this$createClientPlugin.t8a_1.a8d_1;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
  var tmp_5;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = firstOrNull(withQuality);
    tmp_5 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.pm_1;
  } else {
    tmp_5 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_5;
  var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().c79_1 : tmp3_elvis_lhs;
  var tmp_6 = RenderRequestHook_instance;
  $this$createClientPlugin.w8a(tmp_6, HttpPlainText$lambda$slambda(acceptCharsetHeader, requestCharset));
  $this$createClientPlugin.d8d(HttpPlainText$lambda$slambda_0(responseCharsetFallback));
  return Unit_instance;
}
function HttpPlainText$lambda$lambda(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.qm_1;
  var tmp$ret$2 = a.qm_1;
  return compareValues(tmp, tmp$ret$2);
}
function HttpPlainText$lambda$lambda_0(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_name(a);
  var tmp$ret$2 = get_name(b);
  return compareValues(tmp, tmp$ret$2);
}
function invoke$wrapContent(requestCharset, request, content, requestContentType) {
  var contentType = requestContentType == null ? Text_getInstance().i7j_1 : requestContentType;
  var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
  var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
  get_LOGGER_2().z7g('Sending request body to ' + request.v85_1.toString() + ' as text/plain with charset ' + charset_0.toString());
  return new TextContent(content, withCharset(contentType, charset_0));
}
function invoke$read(responseCharsetFallback, call, body) {
  var tmp0_elvis_lhs = charset_0(call.t84());
  var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
  get_LOGGER_2().z7g('Reading response body for ' + call.m86().v86().toString() + ' as String with charset ' + actualCharset.toString());
  return readText_0(body, actualCharset);
}
function invoke$addAcceptCharsetHeader(_this__u8e3s4, value) {
  if (value == null || !(_this__u8e3s4.x85_1.wi('Accept-Charset') == null))
    return Unit_instance;
  get_LOGGER_2().z7g('Adding Accept-Charset=' + value + ' to ' + _this__u8e3s4.v85_1.toString());
  _this__u8e3s4.x85_1.e7c('Accept-Charset', value);
}
function HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset) {
  return constructCallableReference(function *(request, content, $completion) {
    invoke$addAcceptCharsetHeader(request, $acceptCharsetHeader);
    var tmp;
    if (!(typeof content === 'string')) {
      return null;
    }
    var contentType_0 = contentType(request);
    var tmp_0;
    if (!(contentType_0 == null) && !(contentType_0.p7h_1 === Text_getInstance().i7j_1.p7h_1)) {
      return null;
    }
    return invoke$wrapContent($requestCharset, request, content, contentType_0);
  }, 2);
}
function HttpPlainText$lambda$slambda_0($responseCharsetFallback) {
  return constructCallableReference(function *($this$transformResponseBody, response, content, requestedType, $completion) {
    var tmp;
    if (!requestedType.n7g_1.equals(PrimitiveClasses_getInstance().sg())) {
      return null;
    }
    var bodyBytes = yield* readRemaining(content, $completion);
    return invoke$read($responseCharsetFallback, response.t86(), bodyBytes);
  }, 4);
}
var properties_initialized_HttpPlainText_kt_2nx4ox;
function _init_properties_HttpPlainText_kt__iy89z1() {
  if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
    properties_initialized_HttpPlainText_kt_2nx4ox = true;
    LOGGER_2 = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
    HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
  }
}
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER_3() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER_3;
}
var LOGGER_3;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.x7s_1;
  return tmp0_subject === Companion_getInstance_1().g7r_1.x7s_1 || tmp0_subject === Companion_getInstance_1().h7r_1.x7s_1 || (tmp0_subject === Companion_getInstance_1().m7r_1.x7s_1 || (tmp0_subject === Companion_getInstance_1().n7r_1.x7s_1 || tmp0_subject === Companion_getInstance_1().i7r_1.x7s_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  return constructCallableReference(() => new HttpRedirectConfig(), 0, 0, 33, '<init>');
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.t8a_1.f8d_1;
  var allowHttpsDowngrade = $this$createClientPlugin.t8a_1.g8d_1;
  var tmp = Send_instance;
  $this$createClientPlugin.w8a(tmp, HttpRedirect$lambda$slambda(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.m86().v86().d7u_1;
    var previousAuthority = get_authority(call.m86().v86());
    if (!isRedirect(call.t84().c87()))
      return call;
    var location = call.t84().z7p().wi('Location');
    if (location == null) {
      get_LOGGER_3().x7g('Location header missing from redirect response ' + call.m86().v86().toString() + '; returning response as is');
      return call;
    }
    client.m84_1.b7h(get_HttpResponseRedirectEvent(), call.t84());
    get_LOGGER_3().z7g('Received redirect response to ' + location + ' for request ' + call.m86().v86().toString());
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpRequestBuilder();
    this_0.n89(requestBuilder);
    this_0.v85_1.n7t_1.a5();
    takeFrom(this_0.v85_1, location);
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_0.v85_1.q7t())) {
      get_LOGGER_3().z7g('Blocked redirect from ' + call.m86().v86().toString() + ' to ' + location + ' due to HTTPS downgrade');
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_0.v85_1))) {
      this_0.x85_1.i7c('Authorization');
      get_LOGGER_3().z7g('Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_0.v85_1.a7v()));
    }
    requestBuilder = this_0;
    call = yield* _this__u8e3s4.s8c(requestBuilder, $completion);
  }
}
function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  return constructCallableReference(function *($this$on, request, $completion) {
    var origin = yield* $this$on.s8c(request, $completion);
    var tmp;
    if ($checkHttpMethod && !get_ALLOWED_FOR_REDIRECT().w2(origin.m86().u86())) {
      return origin;
    }
    return yield* /*#__NOINLINE__*/invoke$handleCall($this$on, request, origin, $allowHttpsDowngrade, $this_createClientPlugin.s8a_1, $completion);
  }, 2);
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf_0([Companion_getInstance_2().a7q_1, Companion_getInstance_2().f7q_1]);
    LOGGER_3 = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new EventDefinition();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
function get_LOGGER_4() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return LOGGER_4;
}
var LOGGER_4;
function get_HttpRequestLifecycle() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return HttpRequestLifecycle;
}
var HttpRequestLifecycle;
function PipelineContext$proceed$ref(p0) {
  return constructCallableReference(function *($completion) {
    yield* p0.y7e($completion);
    return Unit_instance;
  }, 0, 9, 34, VOID, [p0]);
}
function SetupRequestContext$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $handler($this$intercept.v7f_1, PipelineContext$proceed$ref($this$intercept), $completion);
    return Unit_instance;
  }, 2);
}
var SetupRequestContext_instance;
function SetupRequestContext_getInstance() {
  return SetupRequestContext_instance;
}
function attachToClientEngineJob(requestJob, clientEngineJob) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var handler = clientEngineJob.g1n(attachToClientEngineJob$lambda(requestJob));
  requestJob.g1n(attachToClientEngineJob$lambda_0(handler));
}
function HttpRequestLifecycle$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var tmp = SetupRequestContext_instance;
  $this$createClientPlugin.w8a(tmp, HttpRequestLifecycle$lambda$slambda($this$createClientPlugin));
  return Unit_instance;
}
function HttpRequestLifecycle$lambda$slambda($this_createClientPlugin) {
  return constructCallableReference(function *(request, proceed, $completion) {
    var executionContext = SupervisorJob(request.z85_1);
    attachToClientEngineJob(executionContext, ensureNotNull($this_createClientPlugin.s8a_1.f84_1.ae(Key_instance)));
    var tmp;
    try {
      request.z85_1 = executionContext;
      tmp = yield* proceed($completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        executionContext.k1t(cause);
        throw cause;
      } else {
        throw $p;
      }
    }
    finally {
      executionContext.o1t();
    }
    return Unit_instance;
  }, 2);
}
function attachToClientEngineJob$lambda($requestJob) {
  return (cause) => {
    if (!(cause == null)) {
      get_LOGGER_4().z7g('Cancelling request because engine Job failed with error: ' + cause.toString());
      cancel_1($requestJob, 'Engine failed', cause);
    } else {
      get_LOGGER_4().z7g('Cancelling request because engine Job completed');
      $requestJob.o1t();
    }
    return Unit_instance;
  };
}
function attachToClientEngineJob$lambda_0($handler) {
  return (it) => {
    $handler.u1o();
    return Unit_instance;
  };
}
var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
  if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
    properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
    LOGGER_4 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    HttpRequestLifecycle = createClientPlugin_0('RequestLifecycle', HttpRequestLifecycle$lambda);
  }
}
function get_LOGGER_5() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return LOGGER_5;
}
var LOGGER_5;
function get_HttpRequestRetryEvent() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return HttpRequestRetryEvent;
}
var HttpRequestRetryEvent;
var HttpRequestRetry;
function get_MaxRetriesPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return MaxRetriesPerRequestAttributeKey;
}
var MaxRetriesPerRequestAttributeKey;
function get_ShouldRetryPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryPerRequestAttributeKey;
}
var ShouldRetryPerRequestAttributeKey;
function get_ShouldRetryOnExceptionPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ShouldRetryOnExceptionPerRequestAttributeKey;
}
var ShouldRetryOnExceptionPerRequestAttributeKey;
function get_ModifyRequestPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return ModifyRequestPerRequestAttributeKey;
}
var ModifyRequestPerRequestAttributeKey;
function get_RetryDelayPerRequestAttributeKey() {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  return RetryDelayPerRequestAttributeKey;
}
var RetryDelayPerRequestAttributeKey;
function randomMs($this, randomizationMs) {
  return equalsLong(randomizationMs, new Long(0, 0)) ? new Long(0, 0) : Default_getInstance().lr(randomizationMs);
}
function HttpRequestRetryConfig$delay$slambda() {
  return constructCallableReference(function *(it, $completion) {
    yield* delay(it, $completion);
    return Unit_instance;
  }, 1);
}
function HttpRequestRetryConfig$modifyRequest$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function HttpRequestRetryConfig$retryOnException$lambda($retryOnTimeout) {
  return ($this$retryOnExceptionIf, _unused_var__etf5q3, cause) => {
    var tmp;
    if (isTimeoutException(cause)) {
      tmp = $retryOnTimeout;
    } else {
      if (cause instanceof CancellationException_0) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  };
}
function HttpRequestRetryConfig$retryOnServerErrors$lambda($this$retryIf, _unused_var__etf5q3, response) {
  // Inline function 'kotlin.let' call
  var it = response.c87().x7s_1;
  return 500 <= it ? it <= 599 : false;
}
function HttpRequestRetryConfig$delayMillis$lambda($respectRetryAfterHeader, $block) {
  return (_this__u8e3s4, it) => {
    var tmp;
    if ($respectRetryAfterHeader) {
      var tmp0_safe_receiver = _this__u8e3s4.n8d_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z7p();
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.wi('Retry-After');
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toLongOrNull(tmp2_safe_receiver);
      var tmp_0;
      if (tmp3_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.Long.times' call
        tmp_0 = multiply(tmp3_safe_receiver, fromInt(1000));
      }
      var retryAfter = tmp_0;
      var tmp0 = $block(_this__u8e3s4, it);
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = retryAfter == null ? new Long(0, 0) : retryAfter;
      tmp = compare(tmp0, b) >= 0 ? tmp0 : b;
    } else {
      tmp = $block(_this__u8e3s4, it);
    }
    return tmp;
  };
}
function HttpRequestRetryConfig$exponentialDelay$lambda($base, $baseDelayMs, $maxDelayMs, this$0, $randomizationMs) {
  return ($this$delayMillis, retry) => {
    var tmp0 = $base;
    // Inline function 'kotlin.math.pow' call
    var n = retry - 1 | 0;
    var tmp$ret$0 = Math.pow(tmp0, n);
    var tmp0_0 = numberToLong(tmp$ret$0 * toNumber($baseDelayMs));
    // Inline function 'kotlin.comparisons.minOf' call
    var b = $maxDelayMs;
    var delay = compare(tmp0_0, b) <= 0 ? tmp0_0 : b;
    return add(delay, randomMs(this$0, $randomizationMs));
  };
}
function *throwOnInvalidResponseBody(_this__u8e3s4, $completion) {
  var tmp;
  if (get_isSaved(_this__u8e3s4)) {
    // Inline function 'kotlin.run' call
    var $this$run = _this__u8e3s4.b87();
    var tmp_0;
    try {
      tmp_0 = yield* $this$run.e77(VOID, $completion);
    }finally {
      // Inline function 'kotlin.runCatching' call
      var tmp_1;
      try {
        cancel_3($this$run);
        // Inline function 'kotlin.Companion.success' call
        tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      // Inline function 'kotlin.onFailure' call
      var this_0 = tmp_1;
      var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        get_LOGGER_5().y7g('Failed to close response body channel', tmp0_safe_receiver);
      }
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
function isTimeoutException(_this__u8e3s4) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var exception = unwrapCancellationException(_this__u8e3s4);
  var tmp;
  var tmp_0;
  if (exception instanceof HttpRequestTimeoutException) {
    tmp_0 = true;
  } else {
    tmp_0 = exception instanceof ConnectTimeoutException;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = exception instanceof SocketTimeoutException;
  }
  return tmp;
}
function HttpRequestRetryConfig$_init_$ref_mqbboi() {
  return constructCallableReference(() => new HttpRequestRetryConfig(), 0, 0, 35, '<init>');
}
function HttpRequestRetry$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestRetry_kt__h4xjtt();
  var shouldRetry = $this$createClientPlugin.t8a_1.x8d();
  var shouldRetryOnException = $this$createClientPlugin.t8a_1.y8d();
  var delayMillis = $this$createClientPlugin.t8a_1.z8d();
  var delay = $this$createClientPlugin.t8a_1.s8d_1;
  var maxRetries = $this$createClientPlugin.t8a_1.u8d_1;
  var modifyRequest = $this$createClientPlugin.t8a_1.t8d_1;
  $this$createClientPlugin.m8e(HttpRequestRetry$lambda$slambda(maxRetries));
  var tmp = Send_instance;
  $this$createClientPlugin.w8a(tmp, HttpRequestRetry$lambda$slambda_0(shouldRetry, shouldRetryOnException, maxRetries, delayMillis, modifyRequest, $this$createClientPlugin, delay));
  return Unit_instance;
}
function HttpRequestRetry$lambda$prepareRequest$lambda($subRequest) {
  return (cause) => {
    var tmp = $subRequest.z85_1;
    var subRequestJob = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
    if (cause == null) {
      subRequestJob.o1t();
    } else {
      subRequestJob.k1t(cause);
    }
    return Unit_instance;
  };
}
function invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call) {
  return retryCount < maxRetries && shouldRetry(new HttpRetryShouldRetryContext(retryCount + 1 | 0), call.m86(), call.t84());
}
function invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetry, subRequest, cause) {
  return retryCount < maxRetries && shouldRetry(new HttpRetryShouldRetryContext(retryCount + 1 | 0), subRequest, cause);
}
function invoke$prepareRequest(request) {
  var subRequest = (new HttpRequestBuilder()).n8e(request);
  var tmp = request.z85_1;
  tmp.g1n(HttpRequestRetry$lambda$prepareRequest$lambda(subRequest));
  return subRequest;
}
function HttpRequestRetry$lambda$slambda($maxRetries) {
  return constructCallableReference(function *($this$onRequest, request, _unused_var__etf5q3, $completion) {
    var tmp0_elvis_lhs = request.a86_1.h7a(get_MaxRetriesPerRequestAttributeKey());
    var maxRetriesValue = tmp0_elvis_lhs == null ? $maxRetries : tmp0_elvis_lhs;
    request.a86_1.j7a(get_MaxRetriesPerRequestAttributeKey(), maxRetriesValue);
    return Unit_instance;
  }, 3);
}
function HttpRequestRetry$lambda$slambda_0($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay) {
  return constructCallableReference(function *($this$on, request, $completion) {
    var retryCount = 0;
    var tmp0_elvis_lhs = request.a86_1.h7a(get_ShouldRetryPerRequestAttributeKey());
    var shouldRetry = tmp0_elvis_lhs == null ? $shouldRetry : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = request.a86_1.h7a(get_ShouldRetryOnExceptionPerRequestAttributeKey());
    var shouldRetryOnException = tmp1_elvis_lhs == null ? $shouldRetryOnException : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = request.a86_1.h7a(get_MaxRetriesPerRequestAttributeKey());
    var maxRetries = tmp2_elvis_lhs == null ? $maxRetries : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = request.a86_1.h7a(get_RetryDelayPerRequestAttributeKey());
    var delayMillis = tmp3_elvis_lhs == null ? $delayMillis : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = request.a86_1.h7a(get_ModifyRequestPerRequestAttributeKey());
    var modifyRequest = tmp4_elvis_lhs == null ? $modifyRequest : tmp4_elvis_lhs;
    var call;
    var lastRetryData = null;
    $l$loop: while (true) {
      var subRequest = invoke$prepareRequest(request);
      var tmp;
      try {
        if (!(lastRetryData == null)) {
          var modifyRequestContext = new HttpRetryModifyRequestContext(request, lastRetryData.k8d_1, lastRetryData.l8d_1, lastRetryData.j8d_1);
          modifyRequest(modifyRequestContext, subRequest);
        }
        call = yield* $this$on.s8c(subRequest, $completion);
        if (!invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call)) {
          yield* /*#__NOINLINE__*/throwOnInvalidResponseBody(call.t84(), $completion);
          break $l$loop;
        }
        retryCount = retryCount + 1 | 0;
        tmp = new HttpRetryEventData(subRequest, retryCount, call.t84(), null);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var cause = $p;
          if (!invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetryOnException, subRequest, cause)) {
            throw cause;
          }
          retryCount = retryCount + 1 | 0;
          tmp_0 = new HttpRetryEventData(subRequest, retryCount, null, cause);
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var retryData = tmp;
      lastRetryData = retryData;
      $this_createClientPlugin.s8a_1.m84_1.b7h(get_HttpRequestRetryEvent(), lastRetryData);
      var delayContext = new HttpRetryDelayContext(lastRetryData.i8d_1, lastRetryData.k8d_1, lastRetryData.l8d_1);
      yield* $delay(delayMillis(delayContext, retryCount), $completion);
      get_LOGGER_5().z7g('Retrying request ' + request.v85_1.toString() + ' attempt: ' + retryCount);
    }
    return call;
  }, 2);
}
var properties_initialized_HttpRequestRetry_kt_jcpv6l;
function _init_properties_HttpRequestRetry_kt__h4xjtt() {
  if (!properties_initialized_HttpRequestRetry_kt_jcpv6l) {
    properties_initialized_HttpRequestRetry_kt_jcpv6l = true;
    LOGGER_5 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestRetry');
    HttpRequestRetryEvent = new EventDefinition();
    var tmp = HttpRequestRetryConfig$_init_$ref_mqbboi();
    HttpRequestRetry = createClientPlugin('RetryFeature', tmp, HttpRequestRetry$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'MaxRetriesPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().ng();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    MaxRetriesPerRequestAttributeKey = new AttributeKey(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'ShouldRetryPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_3 = PrimitiveClasses_getInstance().functionClass(3);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_4;
    try {
      tmp_4 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequest), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpResponse), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false);
    } catch ($p_0) {
      var tmp_5;
      if ($p_0 instanceof Error) {
        var _unused_var__etf5q3_0 = $p_0;
        tmp_5 = null;
      } else {
        throw $p_0;
      }
      tmp_4 = tmp_5;
    }
    var tmp$ret$2_0 = tmp_4;
    var tmp$ret$1_0 = new TypeInfo(tmp_3, tmp$ret$2_0);
    ShouldRetryPerRequestAttributeKey = new AttributeKey(name_0, tmp$ret$1_0);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_1 = 'ShouldRetryOnExceptionPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_6 = PrimitiveClasses_getInstance().functionClass(3);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_7;
    try {
      tmp_7 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().tg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false);
    } catch ($p_1) {
      var tmp_8;
      if ($p_1 instanceof Error) {
        var _unused_var__etf5q3_1 = $p_1;
        tmp_8 = null;
      } else {
        throw $p_1;
      }
      tmp_7 = tmp_8;
    }
    var tmp$ret$2_1 = tmp_7;
    var tmp$ret$1_1 = new TypeInfo(tmp_6, tmp$ret$2_1);
    ShouldRetryOnExceptionPerRequestAttributeKey = new AttributeKey(name_1, tmp$ret$1_1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_2 = 'ModifyRequestPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_9 = PrimitiveClasses_getInstance().functionClass(2);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_10;
    try {
      tmp_10 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryModifyRequestContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false);
    } catch ($p_2) {
      var tmp_11;
      if ($p_2 instanceof Error) {
        var _unused_var__etf5q3_2 = $p_2;
        tmp_11 = null;
      } else {
        throw $p_2;
      }
      tmp_10 = tmp_11;
    }
    var tmp$ret$2_2 = tmp_10;
    var tmp$ret$1_2 = new TypeInfo(tmp_9, tmp$ret$2_2);
    ModifyRequestPerRequestAttributeKey = new AttributeKey(name_2, tmp$ret$1_2);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_3 = 'RetryDelayPerRequestAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_12 = PrimitiveClasses_getInstance().functionClass(2);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_13;
    try {
      tmp_13 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryDelayContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Long), arrayOf([]), false))]), false);
    } catch ($p_3) {
      var tmp_14;
      if ($p_3 instanceof Error) {
        var _unused_var__etf5q3_3 = $p_3;
        tmp_14 = null;
      } else {
        throw $p_3;
      }
      tmp_13 = tmp_14;
    }
    var tmp$ret$2_3 = tmp_13;
    var tmp$ret$1_3 = new TypeInfo(tmp_12, tmp$ret$2_3);
    RetryDelayPerRequestAttributeKey = new AttributeKey(name_3, tmp$ret$1_3);
  }
}
function HttpSend$Plugin$install$slambda($plugin, $scope) {
  return constructCallableReference(function *($this$intercept, content, $completion) {
    // Inline function 'kotlin.check' call
    if (!(content instanceof OutgoingContent)) {
      var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(content)) + ', with Content-Type: ' + toString_0(contentType($this$intercept.v7f_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
      throw IllegalStateException.o(toString(message));
    }
    // Inline function 'io.ktor.client.request.setBody' call
    var this_0 = $this$intercept.v7f_1;
    if (content == null) {
      this_0.y85_1 = NullBody_instance;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(OutgoingContent);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$4 = tmp_0;
      var tmp$ret$3 = new TypeInfo(tmp, tmp$ret$4);
      this_0.o89(tmp$ret$3);
    } else {
      if (content instanceof OutgoingContent) {
        this_0.y85_1 = content;
        this_0.o89(null);
      } else {
        this_0.y85_1 = content;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_2 = getKClass(OutgoingContent);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_3;
        try {
          tmp_3 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
        } catch ($p_0) {
          var tmp_4;
          if ($p_0 instanceof Error) {
            var _unused_var__etf5q3_0 = $p_0;
            tmp_4 = null;
          } else {
            throw $p_0;
          }
          tmp_3 = tmp_4;
        }
        var tmp$ret$6 = tmp_3;
        var tmp$ret$5 = new TypeInfo(tmp_2, tmp$ret$6);
        this_0.o89(tmp$ret$5);
      }
    }
    var maxRetries = $this$intercept.v7f_1.a86_1.h7a(get_MaxRetriesPerRequestAttributeKey());
    var tmp_5;
    if (!(maxRetries == null) && maxRetries >= $plugin.o8e_1) {
      var tmp_6;
      if (maxRetries < 2147483647) {
        tmp_6 = maxRetries + 1 | 0;
      } else {
        tmp_6 = maxRetries;
      }
      tmp_5 = tmp_6;
    } else {
      tmp_5 = $plugin.o8e_1;
    }
    var maxSendCount = tmp_5;
    var realSender = new DefaultSender(maxSendCount, $scope);
    var interceptedSender = realSender;
    var _iterator__ex2g4s = reversed($plugin.p8e_1).p1();
    while (_iterator__ex2g4s.q1()) {
      var interceptor = _iterator__ex2g4s.r1();
      interceptedSender = new InterceptedSender(interceptor, interceptedSender);
    }
    var call = yield* interceptedSender.q8e($this$intercept.v7f_1, $completion);
    yield* $this$intercept.x7e(call, $completion);
    return Unit_instance;
  }, 2);
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new Plugin();
  return Plugin_instance;
}
var HttpTimeoutCapability_instance;
function HttpTimeoutCapability_getInstance() {
  return HttpTimeoutCapability_instance;
}
function get_SKIP_SAVE_BODY() {
  _init_properties_SaveBody_kt__lbc3fj();
  return SKIP_SAVE_BODY;
}
var SKIP_SAVE_BODY;
function get_RESPONSE_BODY_SAVED() {
  _init_properties_SaveBody_kt__lbc3fj();
  return RESPONSE_BODY_SAVED;
}
var RESPONSE_BODY_SAVED;
function get_LOGGER_6() {
  _init_properties_SaveBody_kt__lbc3fj();
  var tmp0 = LOGGER$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('LOGGER', 0, tmp, _get_LOGGER_$ref_77hhxy(), null);
  return tmp0.k3();
}
var LOGGER$delegate;
function get_SaveBody() {
  _init_properties_SaveBody_kt__lbc3fj();
  return SaveBody;
}
var SaveBody;
var SaveBodyPlugin;
function get_isSaved(_this__u8e3s4) {
  _init_properties_SaveBody_kt__lbc3fj();
  return _this__u8e3s4.t86().n86().i7a(get_RESPONSE_BODY_SAVED());
}
function skipSaveBody(_this__u8e3s4) {
  _init_properties_SaveBody_kt__lbc3fj();
  _this__u8e3s4.a86_1.j7a(get_SKIP_SAVE_BODY(), Unit_instance);
}
function LOGGER$delegate$lambda() {
  _init_properties_SaveBody_kt__lbc3fj();
  return KtorSimpleLogger('io.ktor.client.plugins.SaveBody');
}
function _get_LOGGER_$ref_77hhxy() {
  return constructCallableReference(() => get_LOGGER_6(), 0, 0, 36);
}
function SaveBody$lambda($this$createClientPlugin) {
  _init_properties_SaveBody_kt__lbc3fj();
  var tmp = Phases_getInstance_2().o8a_1;
  $this$createClientPlugin.s8a_1.j84_1.z7f(tmp, SaveBody$lambda$slambda());
  return Unit_instance;
}
function SaveBody$lambda$slambda() {
  return constructCallableReference(function *($this$intercept, response, $completion) {
    var call = response.t86();
    var attributes = call.n86();
    var tmp;
    if (attributes.i7a(get_SKIP_SAVE_BODY())) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_0 = get_LOGGER_6();
      if (get_isTraceEnabled(this_0)) {
        var tmp$ret$1 = 'Skipping body saving for ' + call.m86().v86().toString();
        this_0.z7g(tmp$ret$1);
      }
      return Unit_instance;
    }
    var tmp_0;
    try {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_1 = get_LOGGER_6();
      if (get_isTraceEnabled(this_1)) {
        var tmp$ret$3 = 'Saving body for ' + call.m86().v86().toString();
        this_1.z7g(tmp$ret$3);
      }
      tmp_0 = (yield* save(call, $completion)).t84();
    }finally {
      // Inline function 'kotlin.runCatching' call
      var tmp_1;
      try {
        cancel_3(response.b87());
        // Inline function 'kotlin.Companion.success' call
        tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      // Inline function 'kotlin.onFailure' call
      var this_2 = tmp_1;
      var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_2);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        get_LOGGER_6().y7g('Failed to cancel response body', tmp0_safe_receiver);
      }
    }
    var savedResponse = tmp_0;
    attributes.j7a(get_RESPONSE_BODY_SAVED(), Unit_instance);
    yield* $this$intercept.x7e(savedResponse, $completion);
    return Unit_instance;
  }, 2);
}
function SaveBodyPluginConfig$_init_$ref_lwjaof() {
  return constructCallableReference(() => new SaveBodyPluginConfig(), 0, 0, 37, '<init>');
}
function SaveBodyPlugin$lambda($this$createClientPlugin) {
  _init_properties_SaveBody_kt__lbc3fj();
  if ($this$createClientPlugin.t8a_1.h8f_1) {
    get_LOGGER_6().x7g('It is no longer possible to disable body saving for all requests. Use client.prepareRequest(...).execute { ... } syntax to prevent saving the body in memory.\n\nThis API is deprecated and will be removed in Ktor 4.0.0\nIf you were relying on this functionality, share your use case by commenting on this issue: https://youtrack.jetbrains.com/issue/KTOR-8367/');
  } else {
    get_LOGGER_6().x7g('The SaveBodyPlugin plugin is deprecated and can be safely removed. Request bodies are now saved in memory by default for all non-streaming responses.');
  }
  return Unit_instance;
}
var properties_initialized_SaveBody_kt_hzvee7;
function _init_properties_SaveBody_kt__lbc3fj() {
  if (!properties_initialized_SaveBody_kt_hzvee7) {
    properties_initialized_SaveBody_kt_hzvee7 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'SkipSaveBody';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    SKIP_SAVE_BODY = new AttributeKey(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'ResponseBodySaved';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(Unit);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(Unit), arrayOf([]), false);
    } catch ($p_0) {
      var tmp_4;
      if ($p_0 instanceof Error) {
        var _unused_var__etf5q3_0 = $p_0;
        tmp_4 = null;
      } else {
        throw $p_0;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$2_0 = tmp_3;
    var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$2_0);
    RESPONSE_BODY_SAVED = new AttributeKey(name_0, tmp$ret$1_0);
    LOGGER$delegate = lazy(LOGGER$delegate$lambda);
    SaveBody = createClientPlugin_0('SaveBody', SaveBody$lambda);
    var tmp_5 = SaveBodyPluginConfig$_init_$ref_lwjaof();
    SaveBodyPlugin = createClientPlugin('DoubleReceivePlugin', tmp_5, SaveBodyPlugin$lambda);
  }
}
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
function ClientPluginInstance$onClose$lambda() {
  return Unit_instance;
}
function SetupRequest$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $handler($this$intercept.v7f_1, $completion);
    return Unit_instance;
  }, 2);
}
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
function Send$install$slambda($handler, $client) {
  return constructCallableReference(function *($this$intercept, request, $completion) {
    return yield* $handler(new Sender($this$intercept, $client.f84_1), request, $completion);
  }, 2);
}
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
function createClientPlugin(name, createConfiguration, body) {
  return new ClientPluginImpl(name, createConfiguration, body);
}
function createClientPlugin_0(name, body) {
  return createClientPlugin(name, createClientPlugin$lambda, body);
}
function createClientPlugin$lambda() {
  return Unit_instance;
}
function RequestHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $handler(new OnRequestContext(), $this$intercept.v7f_1, $this$intercept.w7e(), $completion);
    return Unit_instance;
  }, 2);
}
var RequestHook_instance;
function RequestHook_getInstance() {
  return RequestHook_instance;
}
function TransformResponseBodyHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    var _destruct__k2r9zo = $this$intercept.w7e();
    var typeInfo = _destruct__k2r9zo.jm();
    var content = _destruct__k2r9zo.km();
    var tmp;
    if (!isInterface(content, ByteReadChannel)) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = yield* $handler(new TransformResponseBodyContext(), $this$intercept.v7f_1.t84(), content, typeInfo, $completion);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var newContent = tmp_0;
    var tmp_1;
    var tmp_2;
    if (!(newContent instanceof NullBody)) {
      tmp_2 = !typeInfo.n7g_1.sf(newContent);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      throw IllegalStateException.o('transformResponseBody returned ' + toString(newContent) + ' but expected value of type ' + typeInfo.toString());
    }
    yield* $this$intercept.x7e(new HttpResponseContainer(typeInfo, newContent), $completion);
    return Unit_instance;
  }, 2);
}
var TransformResponseBodyHook_instance;
function TransformResponseBodyHook_getInstance() {
  return TransformResponseBodyHook_instance;
}
function cleanup($this, timestamp) {
  removeAll($this.a8g_1, AcceptAllCookiesStorage$cleanup$lambda($this, timestamp));
  var tmp0 = $this.a8g_1;
  // Inline function 'kotlin.collections.fold' call
  var accumulator = new Long(-1, 2147483647);
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var acc = accumulator;
    var cookie = element.jm();
    var createdAt = element.km();
    var tmp0_safe_receiver = maxAgeOrExpires($this, cookie, createdAt);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.math.min' call
      tmp = compare(acc, tmp0_safe_receiver) <= 0 ? acc : tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp;
    accumulator = tmp1_elvis_lhs == null ? acc : tmp1_elvis_lhs;
  }
  var newOldest = accumulator;
  $this.b8g_1.kotlinx$atomicfu$value = newOldest;
}
function maxAgeOrExpires($this, $receiver, createdAt) {
  var tmp0_safe_receiver = $receiver.c7k_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = add(createdAt, multiply(numberToLong(tmp0_safe_receiver), new Long(1000, 0)));
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = $receiver.d7k_1;
    tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e7d_1;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
function AcceptAllCookiesStorage$_init_$lambda_odelxi() {
  return getTimeMillis();
}
function AcceptAllCookiesStorage$addCookie$lambda($cookie, $requestUrl) {
  return (_destruct__k2r9zo) => {
    var existingCookie = _destruct__k2r9zo.jm();
    return existingCookie.z7j_1 === $cookie.z7j_1 && matches(existingCookie, $requestUrl);
  };
}
function AcceptAllCookiesStorage$cleanup$lambda(this$0, $timestamp) {
  return (_destruct__k2r9zo) => {
    var cookie = _destruct__k2r9zo.jm();
    var createdAt = _destruct__k2r9zo.km();
    var tmp0_elvis_lhs = maxAgeOrExpires(this$0, cookie, createdAt);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var expires = tmp;
    return compare(expires, $timestamp) < 0;
  };
}
function matches(_this__u8e3s4, requestUrl) {
  var tmp0_safe_receiver = _this__u8e3s4.e7k_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toLowerCasePreservingASCIIRules(tmp0_safe_receiver);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : trimStart(tmp1_safe_receiver, charArrayOf([_Char___init__impl__6a9atx(46)]));
  var tmp;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Domain field should have the default value';
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var domain = tmp;
  // Inline function 'kotlin.with' call
  _this__u8e3s4.f7k_1;
  var tmp0_elvis_lhs = _this__u8e3s4.f7k_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Path field should have the default value';
    throw IllegalStateException.o(toString(message_0));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var current = tmp_0;
  var path = endsWith(current, _Char___init__impl__6a9atx(47)) ? current : '' + _this__u8e3s4.f7k_1 + '/';
  var host = toLowerCasePreservingASCIIRules(requestUrl.r7t_1);
  // Inline function 'kotlin.let' call
  var pathInRequest = requestUrl.i7v();
  var requestPath = endsWith(pathInRequest, _Char___init__impl__6a9atx(47)) ? pathInRequest : pathInRequest + '/';
  if (!(host === domain) && (hostIsIp(host) || !endsWith_0(host, '.' + domain))) {
    return false;
  }
  if (!(path === '/') && !(requestPath === path) && !startsWith(requestPath, path)) {
    return false;
  }
  return !(_this__u8e3s4.g7k_1 && !isSecure(requestUrl.d7u_1));
}
function fillDefaults(_this__u8e3s4, requestUrl) {
  var result = _this__u8e3s4;
  var tmp0_safe_receiver = result.f7k_1;
  if (!((tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, '/')) === true)) {
    result = result.l7k(VOID, VOID, VOID, VOID, VOID, VOID, requestUrl.i7v());
  }
  // Inline function 'kotlin.text.isNullOrBlank' call
  var this_0 = result.e7k_1;
  if (this_0 == null || isBlank(this_0)) {
    result = result.l7k(VOID, VOID, VOID, VOID, VOID, requestUrl.r7t_1);
  }
  return result;
}
function get_LOGGER_7() {
  _init_properties_HttpCookies_kt__vu19yt();
  return LOGGER_6;
}
var LOGGER_6;
function HttpCookies$Companion$install$slambda($plugin) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $plugin.i8g($this$intercept.v7f_1, $completion);
    return Unit_instance;
  }, 2);
}
function HttpCookies$Companion$install$slambda_0($plugin) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $plugin.j8g($this$intercept.v7f_1, $completion);
    return Unit_instance;
  }, 2);
}
function HttpCookies$Companion$install$slambda_1($plugin) {
  return constructCallableReference(function *($this$intercept, response, $completion) {
    yield* $plugin.k8g(response, $completion);
    return Unit_instance;
  }, 2);
}
var Companion_instance_2;
function Companion_getInstance_10() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
function HttpCookies$initializer$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this$0.g8g_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      yield* element(this$0.f8g_1, $completion);
    }
    return Unit_instance;
  }, 1);
}
function renderClientCookies(cookies) {
  _init_properties_HttpCookies_kt__vu19yt();
  return joinToString(cookies, '; ', VOID, VOID, VOID, VOID, renderCookieHeader$ref());
}
function renderCookieHeader$ref() {
  return constructCallableReference((p0) => renderCookieHeader(p0), 1, 0, 38, 'renderCookieHeader');
}
var properties_initialized_HttpCookies_kt_8twc09;
function _init_properties_HttpCookies_kt__vu19yt() {
  if (!properties_initialized_HttpCookies_kt_8twc09) {
    properties_initialized_HttpCookies_kt_8twc09 = true;
    LOGGER_6 = KtorSimpleLogger('io.ktor.client.plugins.HttpCookies');
  }
}
var SSECapability_instance;
function SSECapability_getInstance() {
  return SSECapability_instance;
}
function get_REQUEST_EXTENSIONS_KEY() {
  _init_properties_WebSockets_kt__jaqpbo();
  return REQUEST_EXTENSIONS_KEY;
}
var REQUEST_EXTENSIONS_KEY;
function get_WEBSOCKETS_KEY() {
  _init_properties_WebSockets_kt__jaqpbo();
  return WEBSOCKETS_KEY;
}
var WEBSOCKETS_KEY;
function get_LOGGER_8() {
  _init_properties_WebSockets_kt__jaqpbo();
  return LOGGER_7;
}
var LOGGER_7;
function WebSockets$Plugin$install$slambda($extensionsSupported, $plugin) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    var tmp;
    if (!isWebsocket($this$intercept.v7f_1.v85_1.q7t())) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_0 = get_LOGGER_8();
      if (get_isTraceEnabled(this_0)) {
        var tmp$ret$1 = 'Skipping WebSocket plugin for non-websocket request: ' + $this$intercept.v7f_1.v85_1.toString();
        this_0.z7g(tmp$ret$1);
      }
      return Unit_instance;
    }
    // Inline function 'io.ktor.util.logging.trace' call
    var this_1 = get_LOGGER_8();
    if (get_isTraceEnabled(this_1)) {
      var tmp$ret$3 = 'Sending WebSocket request ' + $this$intercept.v7f_1.v85_1.toString();
      this_1.z7g(tmp$ret$3);
    }
    $this$intercept.v7f_1.z8g(WebSocketCapability_instance, Unit_instance);
    var tmp_0;
    if ($extensionsSupported) {
      installExtensions($plugin, $this$intercept.v7f_1);
      tmp_0 = Unit_instance;
    }
    $this$intercept.v7f_1.a86_1.k7a(get_WEBSOCKETS_KEY(), $plugin);
    yield* $this$intercept.x7e(new WebSocketContent(), $completion);
    return Unit_instance;
  }, 2);
}
function WebSockets$Plugin$install$slambda_0($plugin, $extensionsSupported) {
  return constructCallableReference(function *($this$intercept, _destruct__k2r9zo, $completion) {
    var info = _destruct__k2r9zo.jm();
    var session = _destruct__k2r9zo.km();
    var response = $this$intercept.v7f_1.t84();
    var status = response.c87();
    var requestContent = get_request(response).s2f();
    if (!(requestContent instanceof WebSocketContent)) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_0 = get_LOGGER_8();
      if (get_isTraceEnabled(this_0)) {
        var tmp$ret$1 = 'Skipping non-websocket response from ' + $this$intercept.v7f_1.m86().v86().toString() + ': ' + toString(requestContent);
        this_0.z7g(tmp$ret$1);
      }
      return Unit_instance;
    }
    if (!status.equals(Companion_getInstance_1().v7q_1)) {
      throw WebSocketException.e8h('Handshake exception, expected status code ' + Companion_getInstance_1().v7q_1.x7s_1 + ' but was ' + status.x7s_1);
    }
    if (!isInterface(session, WebSocketSession)) {
      throw WebSocketException.e8h('Handshake exception, expected `WebSocketSession` content but was ' + toString(getKClassFromExpression(session)));
    }
    // Inline function 'io.ktor.util.logging.trace' call
    var this_1 = get_LOGGER_8();
    if (get_isTraceEnabled(this_1)) {
      var tmp$ret$3 = 'Receive websocket session from ' + $this$intercept.v7f_1.m86().v86().toString() + ': ' + toString(session);
      this_1.z7g(tmp$ret$3);
    }
    if (!equalsLong($plugin.g8h_1, new Long(2147483647, 0))) {
      session.r7z($plugin.g8h_1);
    }
    var tmp;
    if (info.n7g_1.equals(getKClass(DefaultClientWebSocketSession))) {
      var defaultSession = $plugin.k8h(session);
      var clientSession = new DefaultClientWebSocketSession($this$intercept.v7f_1, defaultSession);
      var tmp_0;
      if ($extensionsSupported) {
        tmp_0 = completeNegotiation($plugin, $this$intercept.v7f_1);
      } else {
        tmp_0 = emptyList();
      }
      var negotiated = tmp_0;
      // Inline function 'kotlin.apply' call
      clientSession.q7z(negotiated);
      tmp = clientSession;
    } else {
      tmp = new DelegatingClientWebSocketSession($this$intercept.v7f_1, session);
    }
    var clientSession_0 = tmp;
    yield* $this$intercept.x7e(new HttpResponseContainer(info, clientSession_0), $completion);
    return Unit_instance;
  }, 2);
}
function installExtensions($this, context) {
  var installed = $this.h8h_1.j7e();
  context.a86_1.j7a(get_REQUEST_EXTENSIONS_KEY(), installed);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = installed.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var list = element.x82();
    addAll(destination, list);
  }
  var protocols = destination;
  addNegotiatedProtocols($this, context, protocols);
}
function completeNegotiation($this, call) {
  var tmp0_safe_receiver = call.t84().z7p().wi('Sec-WebSocket-Extensions');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = parseWebSocketExtensions(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var serverExtensions = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  var clientExtensions = call.n86().g7a(get_REQUEST_EXTENSIONS_KEY());
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = clientExtensions.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.y82(serverExtensions)) {
      destination.d2(element);
    }
  }
  return destination;
}
function addNegotiatedProtocols($this, context, protocols) {
  if (protocols.n1())
    return Unit_instance;
  var headerValue = joinToString(protocols, ',');
  header(context, 'Sec-WebSocket-Extensions', headerValue);
}
var Plugin_instance_0;
function Plugin_getInstance_0() {
  if (Plugin_instance_0 === VOID)
    new Plugin_0();
  return Plugin_instance_0;
}
var WebSocketExtensionsCapability_instance;
function WebSocketExtensionsCapability_getInstance() {
  return WebSocketExtensionsCapability_instance;
}
var WebSocketCapability_instance;
function WebSocketCapability_getInstance() {
  return WebSocketCapability_instance;
}
var properties_initialized_WebSockets_kt_2t2hw2;
function _init_properties_WebSockets_kt__jaqpbo() {
  if (!properties_initialized_WebSockets_kt_2t2hw2) {
    properties_initialized_WebSockets_kt_2t2hw2 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'Websocket extensions';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtList);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(WebSocketExtension), arrayOf([getStarKTypeProjection()]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    REQUEST_EXTENSIONS_KEY = new AttributeKey(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'Websocket plugin config';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(WebSockets);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(WebSockets), arrayOf([]), false);
    } catch ($p_0) {
      var tmp_4;
      if ($p_0 instanceof Error) {
        var _unused_var__etf5q3_0 = $p_0;
        tmp_4 = null;
      } else {
        throw $p_0;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$2_0 = tmp_3;
    var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$2_0);
    WEBSOCKETS_KEY = new AttributeKey(name_0, tmp$ret$1_0);
    LOGGER_7 = KtorSimpleLogger('io.ktor.client.plugins.websocket.WebSockets');
  }
}
function *webSocketSession(_this__u8e3s4, block, $completion) {
  plugin(_this__u8e3s4, Plugin_getInstance_0());
  var sessionDeferred = CompletableDeferred();
  // Inline function 'io.ktor.client.request.prepareRequest' call
  // Inline function 'kotlin.apply' call
  var this_0 = new HttpRequestBuilder();
  this_0.u8h(webSocketSession$lambda);
  block(this_0);
  // Inline function 'io.ktor.client.request.prepareRequest' call
  var statement = new HttpStatement(this_0, _this__u8e3s4);
  launch(_this__u8e3s4, VOID, VOID, webSocketSession$slambda(statement, sessionDeferred));
  return yield* sessionDeferred.m1q($completion);
}
function webSocketSession$lambda($this$url, it) {
  $this$url.n7u(Companion_getInstance_3().q7u_1);
  $this$url.m7u($this$url.q7t().p7t_1);
  return Unit_instance;
}
function webSocketSession$slambda$slambda$lambda($sessionCompleted) {
  return (it) => {
    if (!(it == null)) {
      $sessionCompleted.k1t(it);
    } else {
      $sessionCompleted.l1t(Unit_instance);
    }
    return Unit_instance;
  };
}
function webSocketSession$slambda$slambda($response, $sessionDeferred) {
  return constructCallableReference(function *($this$withContext, $completion) {
    // Inline function 'io.ktor.client.call.body' call
    var tmp = $response.t86();
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(DefaultClientWebSocketSession);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(DefaultClientWebSocketSession), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    var tmp_3 = yield* tmp.q86(tmp$ret$1, $completion);
    var result = tmp_3 instanceof DefaultClientWebSocketSession ? tmp_3 : THROW_CCE();
    var sessionCompleted = CompletableDeferred();
    $sessionDeferred.l1t(result);
    var tmp_4 = result.u7z();
    tmp_4.b23(webSocketSession$slambda$slambda$lambda(sessionCompleted));
    yield* sessionCompleted.m1q($completion);
    return Unit_instance;
  }, 1);
}
function webSocketSession$slambda$lambda($sessionCompleted) {
  return (it) => {
    if (!(it == null)) {
      $sessionCompleted.k1t(it);
    } else {
      $sessionCompleted.l1t(Unit_instance);
    }
    return Unit_instance;
  };
}
function webSocketSession$slambda($statement, $sessionDeferred) {
  return constructCallableReference(function *($this$launch, $completion) {
    try {
      var tmp0 = $statement;
      $l$block: {
        // Inline function 'io.ktor.client.statement.HttpStatement.body' call
        $l$block_0: {
          // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
          try {
            var response = yield* tmp0.x8h($completion);
            try {
              if (get_useEngineDispatcher()) {
                var tmp = ensureNotNull(response.d1m().ae(Key_instance_0));
                yield* withContext(tmp, webSocketSession$slambda$slambda(response, $sessionDeferred), $completion);
              } else {
                // Inline function 'io.ktor.client.call.body' call
                var tmp_0 = response.t86();
                // Inline function 'io.ktor.util.reflect.typeInfo' call
                var tmp_1 = getKClass(DefaultClientWebSocketSession);
                // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
                var tmp_2;
                try {
                  tmp_2 = createKType(getKClass(DefaultClientWebSocketSession), arrayOf([]), false);
                } catch ($p) {
                  var tmp_3;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_3 = null;
                  } else {
                    throw $p;
                  }
                  tmp_2 = tmp_3;
                }
                var tmp$ret$5 = tmp_2;
                var tmp$ret$4 = new TypeInfo(tmp_1, tmp$ret$5);
                var tmp_4 = yield* tmp_0.q86(tmp$ret$4, $completion);
                var result = tmp_4 instanceof DefaultClientWebSocketSession ? tmp_4 : THROW_CCE();
                var sessionCompleted = CompletableDeferred();
                $sessionDeferred.l1t(result);
                var tmp_5 = result.u7z();
                tmp_5.b23(webSocketSession$slambda$lambda(sessionCompleted));
                yield* sessionCompleted.m1q($completion);
              }
              break $l$block;
            }finally {
              yield* tmp0.y8h(response, $completion);
            }
          } catch ($p_0) {
            if ($p_0 instanceof CancellationException_0) {
              var cause = $p_0;
              throw unwrapCancellationException(cause);
            } else {
              throw $p_0;
            }
          }
        }
      }
    } catch ($p_1) {
      if ($p_1 instanceof Error) {
        var cause_0 = $p_1;
        $sessionDeferred.k1t(cause_0);
      } else {
        throw $p_1;
      }
    }
    return Unit_instance;
  }, 1);
}
function ClientUpgradeContent$content$delegate$lambda() {
  return new ByteChannel();
}
function get_ResponseAdapterAttributeKey() {
  _init_properties_HttpRequest_kt__813lx1();
  return ResponseAdapterAttributeKey;
}
var ResponseAdapterAttributeKey;
var Companion_instance_3;
function Companion_getInstance_11() {
  return Companion_instance_3;
}
function HttpRequestBuilder$setCapability$lambda() {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap.m7();
}
function isUpgradeRequest(_this__u8e3s4) {
  _init_properties_HttpRequest_kt__813lx1();
  var tmp = _this__u8e3s4.i89_1;
  return tmp instanceof ClientUpgradeContent;
}
var properties_initialized_HttpRequest_kt_zh09pz;
function _init_properties_HttpRequest_kt__813lx1() {
  if (!properties_initialized_HttpRequest_kt_zh09pz) {
    properties_initialized_HttpRequest_kt_zh09pz = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ResponseAdapterAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ResponseAdapter);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ResponseAdapter), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    ResponseAdapterAttributeKey = new AttributeKey(name, tmp$ret$1);
  }
}
var Phases_instance;
function Phases_getInstance() {
  if (Phases_instance === VOID)
    new Phases();
  return Phases_instance;
}
var Phases_instance_0;
function Phases_getInstance_0() {
  if (Phases_instance_0 === VOID)
    new Phases_0();
  return Phases_instance_0;
}
function get_BodyTypeAttributeKey() {
  _init_properties_RequestBody_kt__bo3lwf();
  return BodyTypeAttributeKey;
}
var BodyTypeAttributeKey;
var properties_initialized_RequestBody_kt_agyv1b;
function _init_properties_RequestBody_kt__bo3lwf() {
  if (!properties_initialized_RequestBody_kt_agyv1b) {
    properties_initialized_RequestBody_kt_agyv1b = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'BodyTypeAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(TypeInfo);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(TypeInfo), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    BodyTypeAttributeKey = new AttributeKey(name, tmp$ret$1);
  }
}
function header(_this__u8e3s4, key, value) {
  var tmp;
  if (value == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    _this__u8e3s4.z7p().g7c(key, toString(value));
    tmp = Unit_instance;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? Unit_instance : tmp1_elvis_lhs;
}
function get_request(_this__u8e3s4) {
  return _this__u8e3s4.t86().m86();
}
function *bodyAsText(_this__u8e3s4, fallbackCharset, $completion) {
  fallbackCharset = fallbackCharset === VOID ? Charsets_getInstance().c79_1 : fallbackCharset;
  var tmp0_elvis_lhs = charset_0(_this__u8e3s4);
  var originCharset = tmp0_elvis_lhs == null ? fallbackCharset : tmp0_elvis_lhs;
  var decoder = originCharset.f79();
  // Inline function 'io.ktor.client.call.body' call
  var tmp = _this__u8e3s4.t86();
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(Source);
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(Source), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$2 = tmp_1;
  var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
  var tmp_3 = yield* tmp.q86(tmp$ret$1, $completion);
  var input = (!(tmp_3 == null) ? isInterface(tmp_3, Source) : false) ? tmp_3 : THROW_CCE();
  return decode(decoder, input);
}
var Phases_instance_1;
function Phases_getInstance_1() {
  if (Phases_instance_1 === VOID)
    new Phases_1();
  return Phases_instance_1;
}
var Phases_instance_2;
function Phases_getInstance_2() {
  if (Phases_instance_2 === VOID)
    new Phases_2();
  return Phases_instance_2;
}
function observable(_this__u8e3s4, context, contentLength, listener) {
  var tmp = GlobalScope_instance;
  return writer(tmp, context, true, observable$slambda(_this__u8e3s4, listener, contentLength)).b78_1;
}
function observable$slambda($this_observable, $listener, $contentLength) {
  return constructCallableReference(function *($this$writer, $completion) {
    var tmp0 = get_ByteArrayPool();
    $l$block: {
      // Inline function 'io.ktor.utils.io.pool.useInstance' call
      var instance = tmp0.r79();
      try {
        var bytesSend = new Long(0, 0);
        $l$loop: while (!$this_observable.x76()) {
          var read = yield* readAvailable($this_observable, instance, VOID, VOID, $completion);
          if (read <= 0)
            continue $l$loop;
          yield* writeFully($this$writer.d78_1, instance, 0, read, $completion);
          // Inline function 'kotlin.Long.plus' call
          var this_0 = bytesSend;
          bytesSend = add(this_0, fromInt(read));
          yield* $listener.a89(bytesSend, $contentLength, $completion);
        }
        var closedCause = $this_observable.v76();
        close($this$writer.d78_1, closedCause);
        if (closedCause == null && equalsLong(bytesSend, new Long(0, 0))) {
          yield* $listener.a89(bytesSend, $contentLength, $completion);
        }
        break $l$block;
      }finally {
        tmp0.s79(instance);
      }
    }
    return Unit_instance;
  }, 1);
}
function get_HttpRequestCreated() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpRequestCreated;
}
var HttpRequestCreated;
function get_HttpRequestIsReadyForSending() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpRequestIsReadyForSending;
}
var HttpRequestIsReadyForSending;
function get_HttpResponseReceived() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpResponseReceived;
}
var HttpResponseReceived;
function get_HttpResponseReceiveFailed() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpResponseReceiveFailed;
}
var HttpResponseReceiveFailed;
function get_HttpResponseCancelled() {
  _init_properties_ClientEvents_kt__xuvbz8();
  return HttpResponseCancelled;
}
var HttpResponseCancelled;
var properties_initialized_ClientEvents_kt_rdee4m;
function _init_properties_ClientEvents_kt__xuvbz8() {
  if (!properties_initialized_ClientEvents_kt_rdee4m) {
    properties_initialized_ClientEvents_kt_rdee4m = true;
    HttpRequestCreated = new EventDefinition();
    HttpRequestIsReadyForSending = new EventDefinition();
    HttpResponseReceived = new EventDefinition();
    HttpResponseReceiveFailed = new EventDefinition();
    HttpResponseCancelled = new EventDefinition();
  }
}
var EmptyContent_instance;
function EmptyContent_getInstance() {
  if (EmptyContent_instance === VOID)
    new EmptyContent();
  return EmptyContent_instance;
}
function get_DecompressionListAttribute() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  return DecompressionListAttribute;
}
var DecompressionListAttribute;
function dropCompressionHeaders(_this__u8e3s4, method, attributes, alwaysRemove) {
  alwaysRemove = alwaysRemove === VOID ? false : alwaysRemove;
  _init_properties_HeadersUtils_kt__fb6dxx();
  if (method.equals(Companion_getInstance_2().f7q_1) || method.equals(Companion_getInstance_2().g7q_1))
    return Unit_instance;
  var header = _this__u8e3s4.wi('Content-Encoding');
  if (header == null) {
    if (!alwaysRemove)
      return Unit_instance;
  } else {
    var tmp = get_DecompressionListAttribute();
    attributes.m7a(tmp, dropCompressionHeaders$lambda).d2(header);
  }
  _this__u8e3s4.i7c('Content-Encoding');
  _this__u8e3s4.i7c('Content-Length');
}
function dropCompressionHeaders$lambda() {
  _init_properties_HeadersUtils_kt__fb6dxx();
  // Inline function 'kotlin.collections.mutableListOf' call
  return ArrayList.p2();
}
var properties_initialized_HeadersUtils_kt_8c3zal;
function _init_properties_HeadersUtils_kt__fb6dxx() {
  if (!properties_initialized_HeadersUtils_kt_8c3zal) {
    properties_initialized_HeadersUtils_kt_8c3zal = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'DecompressionListAttribute';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtMutableList);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtMutableList), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
    DecompressionListAttribute = new AttributeKey(name, tmp$ret$1);
  }
}
function buildHeaders(block) {
  var tmp;
  if (block === VOID) {
    tmp = buildHeaders$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new HeadersBuilder();
  block(this_0);
  return this_0.j7e();
}
function buildHeaders$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var Companion_instance_4;
function Companion_getInstance_12() {
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
function get_initHook() {
  return initHook;
}
var initHook;
var Js_instance;
function Js_getInstance() {
  return Js_instance;
}
function JsClientEngineConfig$requestInit$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function initHook$init$() {
  engines_getInstance().l8k(Js_instance);
  return Unit_instance;
}
function *createWebSocket($this, urlString_capturingHack, headers, $completion) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = headers.z7b();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (equals_0(element, 'Sec-WebSocket-Protocol', true)) {
      destination.d2(element);
    }
  }
  var protocolHeaderNames = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = protocolHeaderNames.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp0_safe_receiver = headers.y7b(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.d2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = flatten(destination_0);
  var protocols = copyToArray(this_0);
  var tmp;
  if (PlatformUtils_getInstance().n7b_1) {
    tmp = new WebSocket(urlString_capturingHack, protocols);
  } else {
    var ws_import = import('ws');
    var ws_capturingHack = (yield* await_0(ws_import, $completion)).default;
    var headers_capturingHack = new JsClientEngine$createWebSocket$headers_capturingHack$1();
    headers.a7c(JsClientEngine$createWebSocket$lambda(headers_capturingHack));
    tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
  }
  return tmp;
}
function *executeWebSocketRequest($this, request, callContext, $completion) {
  var requestTime = GMTDate();
  var urlString = request.f89_1.toString();
  var wsConfig = request.k89_1.g7a(get_WEBSOCKETS_KEY());
  var socket = yield* /*#__NOINLINE__*/createWebSocket($this, urlString, request.h89_1, $completion);
  var session = new JsWebSocketSession(callContext, socket, wsConfig.j8h_1);
  try {
    yield* awaitConnection(socket, $completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      cancel_2(callContext, CancellationException('Failed to connect to ' + urlString, cause));
      throw cause;
    } else {
      throw $p;
    }
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = socket.protocol;
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_0) > 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var protocol = tmp;
  var headers = !(protocol == null) ? headersOf('Sec-WebSocket-Protocol', protocol) : Companion_getInstance_4().d7l_1;
  return new HttpResponseData(Companion_getInstance_1().v7q_1, requestTime, headers, Companion_getInstance_5().n7q_1, session, callContext);
}
function JsClientEngine$execute$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function JsClientEngine$createWebSocket$lambda($headers_capturingHack) {
  return (name, values) => {
    $headers_capturingHack[name] = joinToString(values, ',');
    return Unit_instance;
  };
}
function mapToKtor(_this__u8e3s4, method, attributes) {
  return buildHeaders(mapToKtor$lambda(_this__u8e3s4, method, attributes));
}
function *awaitConnection(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
    cancellable.u1p();
    $l$block: {
      if (cancellable.a1n()) {
        break $l$block;
      }
      var eventListener = awaitConnection$lambda(cancellable, _this__u8e3s4);
      _this__u8e3s4.addEventListener('open', eventListener);
      _this__u8e3s4.addEventListener('error', eventListener);
      cancellable.y1q(awaitConnection$lambda_0(_this__u8e3s4, eventListener));
    }
    return cancellable.v1p();
  };
}
function asString(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.l1();
  var tmp = JSON;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = ['message', 'target', 'type', 'isTrusted'];
  this_0.m1(tmp.stringify(_this__u8e3s4, tmp$ret$3));
  return this_0.toString();
}
function mapToKtor$lambda$lambda($this_buildHeaders) {
  return (value, key) => {
    $this_buildHeaders.g7c(key, value);
    return Unit_instance;
  };
}
function mapToKtor$lambda($this_mapToKtor, $method, $attributes) {
  return ($this$buildHeaders) => {
    // Inline function 'kotlin.js.asDynamic' call
    $this_mapToKtor.forEach(mapToKtor$lambda$lambda($this$buildHeaders));
    dropCompressionHeaders($this$buildHeaders, $method, $attributes, PlatformUtils_getInstance().n7b_1);
    return Unit_instance;
  };
}
function awaitConnection$lambda($continuation, $this_awaitConnection) {
  return (event) => {
    var tmp0_subject = event.type;
    var tmp;
    if (tmp0_subject === 'open') {
      var tmp0 = $continuation;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = $this_awaitConnection;
      var tmp$ret$1 = _Result___init__impl__xyqfz8(value);
      tmp0.qd(tmp$ret$1);
      tmp = Unit_instance;
    } else if (tmp0_subject === 'error') {
      var tmp0_0 = $continuation;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = WebSocketException.e8h(asString(event));
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0_0.qd(tmp$ret$3);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function awaitConnection$lambda_0($this_awaitConnection, $eventListener) {
  return (it) => {
    $this_awaitConnection.removeEventListener('open', $eventListener);
    $this_awaitConnection.removeEventListener('error', $eventListener);
    var tmp;
    if (!(it == null)) {
      $this_awaitConnection.close();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function *toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
  var jsHeaders = {};
  // Inline function 'io.ktor.client.request.forEachHeader' call
  var skipContentLengthHeader = !get_supportsRequestBody(_this__u8e3s4.g89_1) && isEmpty(_this__u8e3s4.i89_1);
  mergeHeaders(_this__u8e3s4.h89_1, _this__u8e3s4.i89_1, toRaw$lambda(skipContentLengthHeader, jsHeaders));
  var bodyBytes = yield* getBodyBytes(_this__u8e3s4.i89_1, callContext, $completion);
  return buildObject(toRaw$lambda_0(_this__u8e3s4, jsHeaders, clientConfig, bodyBytes));
}
function *getBodyBytes(content, callContext, $completion) {
  var tmp;
  if (content instanceof ByteArrayContent) {
    tmp = content.x7v();
  } else {
    if (content instanceof ReadChannelContent) {
      tmp = readByteArray(yield* readRemaining(content.t7v(), $completion));
    } else {
      if (content instanceof WriteChannelContent) {
        var tmp_0 = GlobalScope_instance;
        tmp = readByteArray(yield* readRemaining(writer(tmp_0, callContext, VOID, getBodyBytes$slambda(content)).b78_1, $completion));
      } else {
        if (content instanceof ContentWrapper) {
          tmp = yield* getBodyBytes(content.a7w(), callContext, $completion);
        } else {
          if (content instanceof NoContent) {
            tmp = null;
          } else {
            if (content instanceof ProtocolUpgrade) {
              throw UnsupportedContentTypeException.z88(content);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function buildObject(block) {
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  block(this_0);
  return this_0;
}
function toRaw$lambda($skipContentLengthHeader, $jsHeaders) {
  return (key, value) => {
    var tmp;
    if ($skipContentLengthHeader && key === 'Content-Length') {
      return Unit_instance;
    }
    $jsHeaders[key] = value;
    return Unit_instance;
  };
}
function toRaw$lambda_0($this_toRaw, $jsHeaders, $clientConfig, $bodyBytes) {
  return ($this$buildObject) => {
    $this$buildObject.method = $this_toRaw.g89_1.k7q_1;
    $this$buildObject.headers = $jsHeaders;
    var tmp;
    if ($clientConfig.h85_1) {
      // Inline function 'org.w3c.fetch.FOLLOW' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'follow';
    } else {
      // Inline function 'org.w3c.fetch.MANUAL' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'manual';
    }
    $this$buildObject.redirect = tmp;
    var tmp0_safe_receiver = $bodyBytes;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
    }
    return Unit_instance;
  };
}
function getBodyBytes$slambda($content) {
  return constructCallableReference(function *($this$writer, $completion) {
    yield* $content.v7v($this$writer.d78_1, $completion);
    return Unit_instance;
  }, 1);
}
function asByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
}
function readBodyBrowser(_this__u8e3s4, response) {
  var tmp0_elvis_lhs = response.body;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Companion_getInstance().v77_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stream = tmp;
  return channelFromStream(_this__u8e3s4, stream);
}
function channelFromStream(_this__u8e3s4, stream) {
  return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda(stream)).b78_1;
}
function *readChunk(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.coroutines.suspendCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var c = $completion;
    var safe = SafeContinuation.ge(intercepted(c));
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then(readChunk$lambda(safe));
    tmp_0.catch(readChunk$lambda_0(safe));
    return safe.he();
  };
}
function channelFromStream$slambda$lambda(it) {
  return Unit_instance;
}
function channelFromStream$slambda($stream) {
  return constructCallableReference(function *($this$writer, $completion) {
    var reader = $stream.getReader();
    var tmp;
    try {
      $l$loop: while (true) {
        var tmp0_elvis_lhs = yield* /*#__NOINLINE__*/readChunk(reader, $completion);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var chunk = tmp_0;
        yield* writeFully($this$writer.d78_1, asByteArray(chunk), VOID, VOID, $completion);
        yield* $this$writer.d78_1.f77($completion);
      }
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var cause = $p;
        var tmp_2 = reader.cancel(cause);
        yield* await_0(tmp_2.catch(channelFromStream$slambda$lambda), $completion);
        throw cause;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 1);
}
function readChunk$lambda($continuation) {
  return (it) => {
    var chunk = it.value;
    var result = it.done ? null : chunk;
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $continuation;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(result);
    this_0.qd(tmp$ret$1);
    return Unit_instance;
  };
}
function readChunk$lambda_0($continuation) {
  return (cause) => {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $continuation;
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
    this_0.qd(tmp$ret$1);
    return Unit_instance;
  };
}
function *commonFetch(input, init, requestConfig, config, callJob, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
    cancellable.u1p();
    var controller = AbortController_0();
    init.signal = controller.signal;
    config.i8k_1(init);
    requestConfig(init);
    callJob.i1n(true, VOID, commonFetch$lambda(controller));
    var tmp;
    if (PlatformUtils_getInstance().n7b_1) {
      tmp = fetch(input, init);
    } else {
      var options = Object.assign(Object.create(null), init, config.j8k_1);
      tmp = fetch(input, options);
    }
    var promise = tmp;
    var tmp_0 = commonFetch$lambda_0(cancellable);
    promise.then(tmp_0, commonFetch$lambda_1(cancellable));
    return cancellable.v1p();
  };
}
function readBody(_this__u8e3s4, response) {
  return readBodyBrowser(_this__u8e3s4, response);
}
function AbortController_0() {
  return new AbortController();
}
function commonFetch$lambda($controller) {
  return (it) => {
    $controller.abort();
    return Unit_instance;
  };
}
function commonFetch$lambda_0($continuation) {
  return (it) => {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $continuation;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(it);
    this_0.qd(tmp$ret$1);
    return Unit_instance;
  };
}
function commonFetch$lambda_1($continuation) {
  return (it) => {
    var tmp0 = $continuation;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = Error_0.ze('Fail to fetch', it);
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.qd(tmp$ret$1);
    return Unit_instance;
  };
}
function isReservedStatusCode($this, $receiver) {
  // Inline function 'kotlin.let' call
  var resolved = Companion_getInstance_7().k7z($receiver);
  return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
}
function JsWebSocketSession$lambda(this$0) {
  return (e) => {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var event = e;
    var data = event.data;
    var tmp;
    if (data instanceof ArrayBuffer) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = new Int8Array(data);
      tmp = Binary.s83(true, tmp$ret$2);
    } else {
      if (!(data == null) ? typeof data === 'string' : false) {
        tmp = Text.k83(data);
      } else {
        var error = IllegalStateException.o('Unknown frame type: ' + event.type);
        this$0.u8k_1.k1t(error);
        throw error;
      }
    }
    var frame = tmp;
    this$0.v8k_1.k22(frame);
    return Unit_instance;
  };
}
function JsWebSocketSession$lambda_0(this$0) {
  return (e) => {
    var cause = WebSocketException.e8h(toString(e));
    this$0.u8k_1.k1t(cause);
    this$0.v8k_1.w22(cause);
    this$0.w8k_1.a23();
    return Unit_instance;
  };
}
function JsWebSocketSession$lambda_1(this$0, $onClose) {
  return (e) => {
    var tmp = e.code;
    var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
    var tmp_1 = e.reason;
    var reason = CloseReason.n7z(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
    this$0.u8k_1.l1t(reason);
    this$0.v8k_1.k22(Close.t80(reason));
    this$0.v8k_1.y22();
    this$0.w8k_1.a23();
    var tmp_2;
    if ($onClose._v == null) {
      throwUninitializedPropertyAccessException('onClose');
    } else {
      tmp_2 = $onClose._v;
    }
    this$0.t8k_1.removeEventListener('close', tmp_2);
    return Unit_instance;
  };
}
function JsWebSocketSession$lambda$lambda($cause, this$0) {
  return (it) => {
    if ($cause == null) {
      this$0.t8k_1.close();
    } else {
      this$0.t8k_1.close(Codes_NORMAL_getInstance().h7z_1, 'Client failed');
    }
    return Unit_instance;
  };
}
function JsWebSocketSession$lambda_2(this$0, $onMessage, $onError) {
  return (cause) => {
    var tmp0 = this$0;
    $l$block: {
      // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.runWhenOpen' call
      if (tmp0.t8k_1.readyState === WebSocket.OPEN) {
        if (cause == null) {
          this$0.t8k_1.close();
        } else {
          this$0.t8k_1.close(Codes_NORMAL_getInstance().h7z_1, 'Client failed');
        }
        break $l$block;
      }
      tmp0.t8k_1.addEventListener('open', JsWebSocketSession$lambda$lambda(cause, this$0));
    }
    this$0.t8k_1.removeEventListener('message', $onMessage);
    this$0.t8k_1.removeEventListener('error', $onError);
    return Unit_instance;
  };
}
function JsWebSocketSession$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlinx.coroutines.channels.consumeEach' call
    var tmp0 = this$0.w8k_1;
    $l$block: {
      // Inline function 'kotlinx.coroutines.channels.consume' call
      var cause = null;
      try {
        var _iterator__ex2g4s = tmp0.p1();
        while (yield* _iterator__ex2g4s.x21($completion)) {
          var e = _iterator__ex2g4s.r1();
          switch (e.w80_1.w1_1) {
            case 0:
              var text = e.x80_1;
              this$0.t8k_1.send(decodeToString(text, 0, 0 + text.length | 0));
              break;
            case 1:
              var tmp = e.x80_1;
              var source = tmp instanceof Int8Array ? tmp : THROW_CCE();
              var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
              this$0.t8k_1.send(frameData);
              break;
            case 2:
              // Inline function 'io.ktor.utils.io.core.buildPacket' call

              var builder = new Buffer();
              writeFully_0(builder, e.x80_1);
              var data = builder;
              var code = data.t72();
              var reason = readText(data);
              this$0.u8k_1.l1t(CloseReason.n7z(code, reason));
              if (isReservedStatusCode(this$0, code)) {
                this$0.t8k_1.close();
              } else {
                this$0.t8k_1.close(code, reason);
              }

              break;
            case 3:
            case 4:
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
        }
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var e_0 = $p;
          cause = e_0;
          throw e_0;
        } else {
          throw $p;
        }
      }
      finally {
        cancelConsumed(tmp0, cause);
      }
    }
    return Unit_instance;
  }, 1);
}
var engines_instance;
function engines_getInstance() {
  if (engines_instance === VOID)
    new engines();
  return engines_instance;
}
function get_useEngineDispatcher() {
  return useEngineDispatcher;
}
var useEngineDispatcher;
function unwrapCancellationException(_this__u8e3s4) {
  var exception = _this__u8e3s4;
  $l$loop: while (exception instanceof CancellationException_0) {
    if (equals(exception, exception.cause)) {
      return _this__u8e3s4;
    }
    exception = exception.cause;
  }
  var tmp0_elvis_lhs = exception;
  return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
}
function get_FACTORY() {
  _init_properties_HttpClient_web_kt__pyfqvb();
  return FACTORY;
}
var FACTORY;
function HttpClient_1(block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_3;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_HttpClient_web_kt__pyfqvb();
  return HttpClient_0(get_FACTORY(), block);
}
function HttpClient$lambda_3(_this__u8e3s4) {
  _init_properties_HttpClient_web_kt__pyfqvb();
  return Unit_instance;
}
var properties_initialized_HttpClient_web_kt_zbb0cl;
function _init_properties_HttpClient_web_kt__pyfqvb() {
  if (!properties_initialized_HttpClient_web_kt_zbb0cl) {
    properties_initialized_HttpClient_web_kt_zbb0cl = true;
    var tmp0 = engines_getInstance();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (!equals(element, Js_instance)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    FACTORY = tmp0_elvis_lhs == null ? Js_instance : tmp0_elvis_lhs;
  }
}
function checkContentLength(contentLength, bodySize, method) {
}
function platformRequestDefaultTransform(contentType, context, body) {
  return null;
}
function platformResponseDefaultTransformers(_this__u8e3s4) {
}
//region block: post-declaration
initMetadataForClass(HttpClient, 'HttpClient', VOID, VOID, [AutoCloseable], [1]);
initMetadataForClass(HttpClientConfig, 'HttpClientConfig', HttpClientConfig);
initMetadataForClass(HttpClientCall, 'HttpClientCall', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(DelegatedCall, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
initMetadataForInterface(HttpRequest, 'HttpRequest');
initMetadataForClass(DelegatedRequest, 'DelegatedRequest', VOID, VOID, [HttpRequest]);
initMetadataForClass(HttpResponse, 'HttpResponse');
initMetadataForClass(DelegatedResponse, 'DelegatedResponse');
initMetadataForCompanion(Companion);
initMetadataForClass(DoubleReceiveException, 'DoubleReceiveException');
initMetadataForClass(NoTransformationFoundException, 'NoTransformationFoundException');
initMetadataForClass(SavedHttpCall, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(SavedHttpRequest, 'SavedHttpRequest', VOID, VOID, [HttpRequest]);
initMetadataForClass(SavedHttpResponse, 'SavedHttpResponse');
initMetadataForClass(UnsupportedContentTypeException, 'UnsupportedContentTypeException');
initMetadataForInterface(ProgressListener, 'ProgressListener', VOID, VOID, VOID, [2]);
initMetadataForClass(ObservableContent, 'ObservableContent');
initMetadataForInterface(HttpClientEngine, 'HttpClientEngine', VOID, VOID, [AutoCloseable], [1]);
initMetadataForClass(ClientEngineClosedException, 'ClientEngineClosedException', ClientEngineClosedException.u89);
protoOf(HttpClientEngineBase).m89 = get_supportedCapabilities;
protoOf(HttpClientEngineBase).x84 = install;
initMetadataForClass(HttpClientEngineBase, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine], [1]);
initMetadataForInterface(HttpClientEngineCapability, 'HttpClientEngineCapability');
initMetadataForClass(HttpClientEngineConfig, 'HttpClientEngineConfig', HttpClientEngineConfig);
initMetadataForCompanion(Companion_0);
protoOf(KtorCallContextElement).ae = get;
protoOf(KtorCallContextElement).dp = fold;
protoOf(KtorCallContextElement).cp = minusKey;
protoOf(KtorCallContextElement).ep = plus;
initMetadataForClass(KtorCallContextElement, 'KtorCallContextElement', VOID, VOID, [Element]);
initMetadataForObject(AfterRenderHook, 'AfterRenderHook');
initMetadataForObject(AfterReceiveHook, 'AfterReceiveHook');
initMetadataForClass(ResponseException, 'ResponseException');
initMetadataForClass(RedirectResponseException, 'RedirectResponseException');
initMetadataForClass(ClientRequestException, 'ClientRequestException');
initMetadataForClass(ServerResponseException, 'ServerResponseException');
initMetadataForClass(defaultTransformers$1$content$1);
initMetadataForClass(defaultTransformers$1$content$2);
initMetadataForClass(HttpCallValidatorConfig, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
initMetadataForClass(ExceptionHandlerWrapper, 'ExceptionHandlerWrapper');
initMetadataForClass(RequestExceptionHandlerWrapper, 'RequestExceptionHandlerWrapper');
initMetadataForObject(RequestError, 'RequestError');
initMetadataForObject(ReceiveError, 'ReceiveError');
protoOf(HttpRequest$1).d1m = get_coroutineContext;
initMetadataForClass(HttpRequest$1, VOID, VOID, VOID, [HttpRequest]);
initMetadataForClass(HttpPlainTextConfig, 'HttpPlainTextConfig', HttpPlainTextConfig);
initMetadataForObject(RenderRequestHook, 'RenderRequestHook');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(HttpRedirectConfig, 'HttpRedirectConfig', HttpRedirectConfig);
initMetadataForObject(SetupRequestContext, 'SetupRequestContext');
initMetadataForClass(HttpRetryEventData, 'HttpRetryEventData');
initMetadataForClass(HttpRequestRetryConfig, 'HttpRequestRetryConfig', HttpRequestRetryConfig);
initMetadataForClass(HttpRetryShouldRetryContext, 'HttpRetryShouldRetryContext');
initMetadataForClass(HttpRetryDelayContext, 'HttpRetryDelayContext');
initMetadataForClass(HttpRetryModifyRequestContext, 'HttpRetryModifyRequestContext');
initMetadataForClass(Config, 'Config', Config);
initMetadataForObject(Plugin, 'Plugin');
initMetadataForClass(InterceptedSender, 'InterceptedSender', VOID, VOID, VOID, [1]);
initMetadataForClass(DefaultSender, 'DefaultSender', VOID, VOID, VOID, [1]);
initMetadataForClass(HttpSend, 'HttpSend');
initMetadataForClass(SendCountExceedException, 'SendCountExceedException');
initMetadataForObject(HttpTimeoutCapability, 'HttpTimeoutCapability', VOID, VOID, [HttpClientEngineCapability]);
initMetadataForClass(HttpRequestTimeoutException, 'HttpRequestTimeoutException', VOID, VOID, [CopyableThrowable]);
initMetadataForClass(SaveBodyPluginConfig, 'SaveBodyPluginConfig', SaveBodyPluginConfig);
initMetadataForClass(HookHandler, 'HookHandler');
initMetadataForClass(ClientPluginBuilder, 'ClientPluginBuilder');
initMetadataForClass(ClientPluginInstance, 'ClientPluginInstance', VOID, VOID, [AutoCloseable]);
initMetadataForObject(SetupRequest, 'SetupRequest');
initMetadataForClass(Sender, 'Sender', VOID, VOID, VOID, [1]);
initMetadataForObject(Send, 'Send');
initMetadataForClass(ClientPluginImpl, 'ClientPluginImpl');
initMetadataForClass(TransformResponseBodyContext, 'TransformResponseBodyContext');
initMetadataForClass(OnRequestContext, 'OnRequestContext');
initMetadataForObject(RequestHook, 'RequestHook');
initMetadataForObject(TransformResponseBodyHook, 'TransformResponseBodyHook');
initMetadataForClass(CookieWithTimestamp, 'CookieWithTimestamp');
initMetadataForClass(AcceptAllCookiesStorage, 'AcceptAllCookiesStorage', AcceptAllCookiesStorage, VOID, [AutoCloseable], [1, 2]);
initMetadataForClass(Config_0, 'Config', Config_0);
initMetadataForCompanion(Companion_1);
initMetadataForClass(HttpCookies, 'HttpCookies', VOID, VOID, [AutoCloseable], [1]);
initMetadataForObject(SSECapability, 'SSECapability', VOID, VOID, [HttpClientEngineCapability]);
initMetadataForClass(DefaultClientWebSocketSession, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession, DefaultWebSocketSession], [1, 0]);
initMetadataForClass(DelegatingClientWebSocketSession, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession], [1, 0]);
initMetadataForClass(ClientUpgradeContent, 'ClientUpgradeContent', VOID, VOID, VOID, [1]);
initMetadataForClass(WebSocketContent, 'WebSocketContent', WebSocketContent, VOID, VOID, [1]);
initMetadataForClass(Config_1, 'Config', Config_1);
initMetadataForObject(Plugin_0, 'Plugin');
initMetadataForClass(WebSockets, 'WebSockets');
initMetadataForObject(WebSocketExtensionsCapability, 'WebSocketExtensionsCapability', VOID, VOID, [HttpClientEngineCapability]);
initMetadataForObject(WebSocketCapability, 'WebSocketCapability', VOID, VOID, [HttpClientEngineCapability]);
initMetadataForClass(WebSocketException, 'WebSocketException');
initMetadataForClass(DefaultHttpRequest, 'DefaultHttpRequest', VOID, VOID, [HttpRequest]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(HttpRequestBuilder, 'HttpRequestBuilder', HttpRequestBuilder);
initMetadataForClass(HttpRequestData, 'HttpRequestData');
initMetadataForClass(HttpResponseData, 'HttpResponseData');
initMetadataForInterface(ResponseAdapter, 'ResponseAdapter');
initMetadataForObject(Phases, 'Phases');
initMetadataForClass(HttpRequestPipeline, 'HttpRequestPipeline', HttpRequestPipeline, VOID, VOID, [2]);
initMetadataForObject(Phases_0, 'Phases');
initMetadataForClass(HttpSendPipeline, 'HttpSendPipeline', HttpSendPipeline, VOID, VOID, [2]);
initMetadataForClass(DefaultHttpResponse, 'DefaultHttpResponse');
initMetadataForObject(Phases_1, 'Phases');
initMetadataForClass(HttpResponsePipeline, 'HttpResponsePipeline', HttpResponsePipeline, VOID, VOID, [2]);
initMetadataForObject(Phases_2, 'Phases');
initMetadataForClass(HttpReceivePipeline, 'HttpReceivePipeline', HttpReceivePipeline, VOID, VOID, [2]);
initMetadataForClass(HttpResponseContainer, 'HttpResponseContainer');
initMetadataForClass(HttpStatement, 'HttpStatement', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(HttpResponseReceiveFail, 'HttpResponseReceiveFail');
initMetadataForObject(EmptyContent, 'EmptyContent');
initMetadataForCompanion(Companion_3);
initMetadataForClass(FetchOptions, 'FetchOptions');
initMetadataForObject(Js, 'Js');
initMetadataForClass(JsClientEngineConfig, 'JsClientEngineConfig', JsClientEngineConfig);
initMetadataForClass(JsClientEngine$createWebSocket$headers_capturingHack$1);
initMetadataForClass(JsClientEngine, 'JsClientEngine', VOID, VOID, VOID, [1, 2]);
protoOf(JsWebSocketSession).v7z = send;
initMetadataForClass(JsWebSocketSession, 'JsWebSocketSession', VOID, VOID, [DefaultWebSocketSession], [0, 1]);
initMetadataForClass(Node, 'Node');
initMetadataForClass(engines$iterator$1);
initMetadataForObject(engines, 'engines', VOID, VOID, [Iterable]);
initMetadataForClass(ConnectTimeoutException, 'ConnectTimeoutException');
initMetadataForClass(InterruptedIOException, 'InterruptedIOException');
initMetadataForClass(SocketTimeoutException, 'SocketTimeoutException');
//endregion
//region block: init
Companion_instance_1 = new Companion_0();
AfterRenderHook_instance = new AfterRenderHook();
AfterReceiveHook_instance = new AfterReceiveHook();
RequestError_instance = new RequestError();
ReceiveError_instance = new ReceiveError();
RenderRequestHook_instance = new RenderRequestHook();
SetupRequestContext_instance = new SetupRequestContext();
HttpTimeoutCapability_instance = new HttpTimeoutCapability();
SetupRequest_instance = new SetupRequest();
Send_instance = new Send();
RequestHook_instance = new RequestHook();
TransformResponseBodyHook_instance = new TransformResponseBodyHook();
SSECapability_instance = new SSECapability();
WebSocketExtensionsCapability_instance = new WebSocketExtensionsCapability();
WebSocketCapability_instance = new WebSocketCapability();
Companion_instance_3 = new Companion_2();
Js_instance = new Js();
useEngineDispatcher = true;
//endregion
//region block: eager init
initHook = initHook$init$();
//endregion
//region block: exports
var initHook_0 = {get: get_initHook};
export {
  initHook_0 as initHook,
};
export {
  Companion_getInstance_10 as Companion_getInstance3lzla9igmrw8j,
  Plugin_getInstance_0 as Plugin_getInstance2t18sf8ddmzc5,
  webSocketSession as webSocketSession13aod734non7u,
  createClientPlugin as createClientPluginjwpvufjows5r,
  AcceptAllCookiesStorage as AcceptAllCookiesStorage10bxtojtvirrv,
  WebSocketException as WebSocketExceptionb5mwyitzck0i,
  pluginOrNull as pluginOrNulleoo3166jvfvu,
  HttpClient_1 as HttpClient3584jcajl7sef,
};
//endregion
